import {
  FETCH_PRODUCT_LIST,
  LOAD_PRODUCT_LIST,
  UPDATE_PRODUCT_LIST_SEQUENCE,
  CHANGE_PRODUCT_LIST_SEQUENCE,
  UpdateProductListSequenceAction,
  UPDATE_PRODUCT_LIST_SEQUENCE_MODE,
  UpdatePinnedProductsAction,
  UPDATE_PINNED_PRODUCTS,
  UpdatePinnedProductsResponse,
  CHANGE_PINNED_PRODUCTS,
  LOAD_SORTING_LIST,
  FETCH_SORTING_LIST,
  LoadSortingRulesListFromSortAction,
  LOAD_SORTED_PRODUCTS,
  LoadSortedProductsListFromSortAction,
  FETCH_SORTED_PRODUCTS,
  BUSINESS_RULES_SERVICE_URL,
  REFRESH_PRODUCT,
  FETCH_PRODUCT_IDS,
  CategoryToProductData,
  RefreshProductSuccessPayload,
  UPDATE_PRODUCT_SEQUENCE,
  UpdateProductSequenceAction,
  UPDATE_PRODUCT_SEQUENCE_LIST_ASYNC,
  GetProductSequenceAction,
  GET_PRODUCT_SEQUENCE_LIST,
  GET_PRODUCT_SEQUENCE,
  LOAD_ASYNC_REQUEST_SERVICE_URL,
  FETCH_IN_PROGRESS_REQUESTS_SNAPSHOT,
  FetchInProgressRequestsSnapshotAction,
  CHECK_CATEGORY_SAVE,
  CheckCategorySaveAction,
  WEBSOCKET_CATEGORY_SAVE_STARTED,
  WEBSOCKET_CATEGORY_SAVE_COMPLETED,
  WEBSOCKET_CATEGORY_SAVE_FAILED,
  WebSocketCategorySaveStartedAction,
  WebSocketCategorySaveCompletedAction,
  WebSocketCategorySaveFailedAction,
  LoadProductsFromCategoryAction,
  FETCH_PRODUCT,
  SET_ACTIVE_SORTING_RULE,
  FETCH_PRODUCTS_COLORS,
  REFRESH_PRODUCT_COLOR,
  FETCH_WATCHED_PRODUCT_LIST,
  ADD_PRODUCT_TO_WATCH_LIST,
  REMOVE_PRODUCT_FROM_WATCH_LIST,
  FETCH_PREV_PRODUCT_IDS,
  FETCH_NEXT_PRODUCT_IDS,
  watchProductAction,
  unWatchProductAction,
  CATEGORY_CHANGE,
  RESET_PRODUCT_LIST,
  CANCEL_PRODUCT_LIST_FETCH,
  LOCK_PRODUCT,
  UNLOCK_PRODUCT,
  FETCH_LOCKS_FOR_CATEGORY,
  LockProductAction,
  LOAD_PRODUCT_POSITION_SERVICE_URL,
  UnLockProductAction,
  GetLocksInCategoryAction,
  LocksInCategory,
  getContentSlotsAction,
  GET_CONTENT_SLOTS,
  LOAD_CONTENT_SLOTS_SERVICE_URL,
  addContentSlotAction,
  ADD_CONTENT_SLOT,
  updateContentSlotAction,
  UPDATE_CONTENT_SLOT,
  deleteContentSlotAction,
  DELETE_CONTENT_SLOT,
  GET_PINNED_PRODUCTS,
  getPinnedProductsAction,
  SET_PINNED_PRODUCTS,
  pinnedProductsAction,
  DISCARD_OUT_OF_POSITION_PRODUCTS,
  DiscardOutOfPositionProductsAction,
  ADD_UPDATE_CONTENT_SLOT,
  addUpdateContentSlotAction,
  ContentSlot,
  DELETE_UPDATE_CONTENT_SLOT,
  deleteUpdateContentSlotAction,
  SET_CONTENT_SLOT_LOADING,
  RESET_CONTENT_SLOT_LOADING,
  FetchPageColorBadgeDataAction,
  FETCH_PAGE_COLOR_BADGE_DATA,
  LOAD_INITIAL_PRODUCTS_DETAILS,
  FETCH_PRODUCT_DETAILS_PER_PAGE,
  UPDATE_SORTED_PRODUCTS_POSITIONS,
  UpdateSortedProductsPositionsAction,
  LOAD_REMAINING_PRODUCTS,
  LoadRemainingProductsAction,
  FETCH_SORTED_PRODUCTS_ASYNC,
  GetSortedProductsListAction,
  PREFETCH_REMAINING_PAGES,
  PrefetchRemainingPagesAction,
} from "./ProductListTypes";
import { RESET_ALL_STATE } from "../RootActions";
import {
  takeEvery,
  put,
  call,
  select,
  all,
  fork,
  join,
  take,
  cancel,
  takeLatest,
  race,
} from "typed-redux-saga/macro";
import GraphQLService from "../../services/GraphQL";
import { callGraphQLApi, callApi, delay } from "../../utils/SagaUtils";
import { updateCategoryPinnedProductsQueryGenerator } from "./ProductListSchema";
import {
  putData,
  getData,
  postData,
  deleteData,
} from "../../services/ApiService";
import { acquireEndpoint } from "../../utils/SmartMerchandiserAPI";
import {
  isSmartSortRuleId,
  isSmartSortPromoteRule,
} from "../../utils/SmartSortUtils";
import { SEQUENCE_MODE_TYPE } from "../../utils/Constants";
import {
  selectCurrencyCode,
  selectCurrentLocale,
  selectCurrentStoreId,
} from "../store-list/StoreListSelectors";
import { selectCurrentCatalogId } from "../catalog/CatalogSelectors";
import {
  selectCurrentCategory,
  selectCategoryNamesByIds,
} from "../category/CategorySelectors";
import { LoadCategoryDetailsById } from "../category/CategoryActions";
import { addGlobalAlertState } from "../global-alert/GlobalAlertActions";
import { showSnackbar } from "../snackbar/SnackbarActions";
import {
  loadProductIdsFromCategory,
  loadPreviousProductIdsFromCategory,
  loadNextProductIdsFromCategory,
  createRefreshProductColorAction,
  refreshProductColorFromList,
  productLoadingCancelled,
  lockProductCompleted,
  unlockProductCompleted,
  updateContentSlotsState,
  deleteContentSlotCompleted,
  updateSortedProductsPositions,
  setRemainingProductsModal,
  clearPendingSaveRequestId,
  websocketCategorySaveCompleted,
  websocketCategorySaveFailed,
  getSortedProductsList,
  asyncSortProgressStart,
  asyncSortProgressStop,
} from "./ProductListActions";
import {
  getUserEmail,
  getUserId,
  getUserName,
} from "../../services/UserService";
import { channel, Task, Channel } from "redux-saga";
import {
  selectProductColors,
  selectProducts,
  selectIsFetchedBySearch,
  selectProductListBySearch,
} from "../product/ProductSelectors";
import {
  selectLockedProducts,
  selectUpdatedLocksInCategory,
  selectPinnedProductIds,
  selectTotal,
  selectContentSlots,
  selectProductListsFetched,
  selectProductListEditSequence,
  selectCurrentPage,
  selectProductListSequenceMode,
  selectRemainingProductsModal,
  selectPrefetchContextId,
  selectPrefetchPauseUntil,
} from "./ProductListSelectors";
import {
  getCurrentPageProductIds,
  handleUndefinedProductsAndLocks,
  updateProductSequencePositions,
} from "../../utils/ProductUtil";
import {
  updateProductListInState,
  updateProductListSequenceMode,
  setLockedUnlockedProducts,
  prefetchRemainingPages,
  setPageFetchStatus,
  setPrefetchContextId,
} from "./ProductListActions";
import AppState from "../AppState";
import { avg, max, min, sum } from "../../utils/ArrayUtils";
import {
  LoadProductDetailsResponseAction,
  SET_PRODUCTS_LOADING_STATE,
  SortedProductScore,
} from "../product/ProductTypes";
import AppEnv from "../../utils/AppEnv";
import {
  QUERY_PRODUCT_BADGE,
  LoadQueryBadgeAction,
} from "../product-badge/ProductBadgeTypes";
import { fetchProductQueryProduct } from "../product-badge/ProductBadgeOperations";
import { selectConfigValue } from "../app-config/AppConfigSelectors";
import { ConfirmOutOfPositionProductsModalId } from "components/left-navigation-panel/ConfirmOutOfPositionProducts";
import { setModalState } from "store/modal/ModalActions";
import { getPinnedProductsOutOfPosition } from "utils/ProductUtil";
import { getInitialProductDetails } from "store/product/ProductActions";
import { selectIsCategoryProductsV2Available } from "store/adapter-config/AdapterConfigSelectors";

let timers: Record<string, number[]> | null = null;

const PRODUCT_BADGES_PAGESIZE = +(AppEnv.PRODUCT_BADGES_PAGESIZE ?? 4);

// Store active badge tasks and channels for cancellation
interface BadgeTaskInfo {
  task: Task;
  channel: Channel<LoadQueryBadgeAction | "END">;
}
let activeBadgeTasks: BadgeTaskInfo[] = [];

// Function to cancel all active badge queries
function* cancelAllBadgeQueries() {
  for (const { task, channel } of activeBadgeTasks) {
    try {
      // Send END to channel to stop processing
      yield* put(channel, "END");
      // Cancel the task
      yield* cancel(task);
    } catch (e) {
      // Task might already be completed, ignore error
    }
  }
  activeBadgeTasks = [];
}

// Common function to load badges for given product IDs
function* loadBadgesForProducts(productIds: string[]) {
  const badgeOverlayEnabled = yield* select(
    selectConfigValue,
    "badgeOverlayEnabled",
  );

  if (badgeOverlayEnabled === "true" && productIds.length > 0) {
    const productBadgeChannel = yield* call(
      channel<LoadQueryBadgeAction | "END">,
    );

    // Create separate worker for badge processing
    const badgeWorker = yield* fork(function* () {
      while (true) {
        const action = yield* take(productBadgeChannel);
        if (action === "END") {
          break;
        }
        yield* call(fetchProductQueryProduct, action);
      }
    });

    // Store task and channel for potential cancellation
    activeBadgeTasks.push({ task: badgeWorker, channel: productBadgeChannel });

    let currentIndex = 0;
    while (currentIndex < productIds.length) {
      const badgeProductIdsChunk = productIds.slice(
        currentIndex,
        currentIndex + PRODUCT_BADGES_PAGESIZE,
      );

      yield* put(productBadgeChannel, {
        type: QUERY_PRODUCT_BADGE.REQUEST,
        payload: {
          productIds: badgeProductIdsChunk,
        },
      });

      currentIndex += PRODUCT_BADGES_PAGESIZE;
    }

    // Stop badge worker
    yield* put(productBadgeChannel, "END");
    yield* join([badgeWorker]);

    // Remove from active tasks after completion
    activeBadgeTasks = activeBadgeTasks.filter(
      (info) => info.task !== badgeWorker,
    );
  }
}

// Helper function to load badges for products that were loaded before cancellation
function* loadBadgesForLoadedProducts(remainingProductIds: string[]) {
  const allProducts = yield* select(selectProducts);
  const productBadgeState = yield* select(
    (state: AppState) => state.productBadge,
  );
  const loadedProductIds = remainingProductIds.filter(
    (id) => allProducts[id]?.productDetailsLoaded,
  );
  // Filter out products that have already been queried for badges
  // (including products with no badges, which won't be in productBadgeAssignments)
  const productsNeedingBadges = loadedProductIds.filter((productId) => {
    // Check if product has been queried (even if it has no badges)
    const hasBeenQueried =
      productBadgeState.queriedProductIds?.includes(productId);
    return !hasBeenQueried;
  });
  if (productsNeedingBadges.length > 0) {
    yield* fork(loadBadgesForProducts, productsNeedingBadges);
  }
}

const recordTime = (timerName: string, start: number, end: number) => {
  if (!timers) {
    return;
  }
  if (!timers[timerName]) {
    timers[timerName] = [];
  }
  timers[timerName].push(end - start);
};

const logTimers = () => {
  if (!timers) {
    return;
  }
  console.debug(
    Object.fromEntries(
      Object.entries(timers).map(([key, timings]) => [
        key,
        {
          cnt: timings.length,
          sum: sum(timings),
          avg: avg(timings),
          min: min(timings),
          max: max(timings),
        },
      ]),
    ),
  );
};

function* getProductsFromCategory(action: LoadProductsFromCategoryAction) {
  try {
    let pauseUntil = yield* select(selectPrefetchPauseUntil);
    while (pauseUntil && Date.now() < pauseUntil) {
      yield* delay(Math.min(50, pauseUntil - Date.now()));
      pauseUntil = yield* select(selectPrefetchPauseUntil);
    }

    yield* put({
      type: FETCH_PRODUCT_LIST.REQUEST,
      payload: action.payload,
    });

    const actionType = FETCH_PRODUCT_LIST;
    const categoryId = action.payload.categoryId;
    const catalogId = action.payload.catalogId;
    const storeId = action.payload.storeId;
    const localeCode = action.payload.localeCode;
    const constName = Object.keys({ FETCH_PRODUCT_LIST })[0].toString();
    const productIds = action.payload.productIds;
    const totalPagesFetched = action.payload.totalPagesFetched;
    const storeListIds = action.payload.storeListIds;
    const isRefreshingAllProducts = action.payload.isRefreshingAllProducts;
    const pageProductIds = action.payload.pageProductIds;
    const isLastPage = action.payload.isLastPage;
    const isRefreshingFromProductGroupMgmt =
      action.payload.isRefreshingFromProductGroupMgmt;
    let commaSeperatedProductIds: string = "";
    if (productIds && Array.isArray(productIds) && productIds.length) {
      commaSeperatedProductIds = String(
        productIds.length > 1
          ? productIds.join(",").toString()
          : productIds.length && productIds[0],
      );
    }

    const endpoint = acquireEndpoint(
      constName,
      commaSeperatedProductIds,
      isRefreshingAllProducts || isRefreshingFromProductGroupMgmt
        ? "true"
        : "false",
    );
    const headersObj = {
      "x-locale-code": localeCode || "default",
      "x-currency-code": "USD",
      "x-store-id": storeId,
      "x-catalog-id": catalogId,
    };
    const t0 = Date.now();
    const response = yield* call(
      callApi,
      actionType,
      getData,
      action.payload,
      endpoint,
      headersObj,
    );
    const t1 = Date.now();
    recordTime(constName, t0, t1);

    const requestContextId = action.payload.requestContextId;
    if (requestContextId) {
      const currentPrefetchContextId = yield* select(selectPrefetchContextId);
      if (currentPrefetchContextId !== requestContextId) {
        if (isLastPage === true) {
          yield* put({ type: FETCH_PRODUCT_LIST.STOP });
        }
        return;
      }
    }

    if (response && response.payload) {
      yield* put<LoadProductDetailsResponseAction>({
        type: FETCH_PRODUCT_LIST.SUCCESS,
        payload: {
          ...response.payload,
          categoryId,
          totalPagesFetched,
          storeListIds,
        },
      });

      // Only get colors if we have firstPageProductIds
      if (pageProductIds) {
        let productIds: string[] = [];
        for (const result of response.payload.results) {
          const isProductHasColors =
            result.cachedProduct?.product?.hasColors ?? false;
          if (
            isProductHasColors &&
            pageProductIds.includes(result.cachedProduct.product.productId)
          ) {
            productIds.push(result.cachedProduct.product.productId);
          }
        }
        if (productIds.length > 0) {
          const colorProductIds = productIds.join(",");
          yield* all([getProductsColorData(action, colorProductIds)]);
        }
      }
      yield* put({ type: SET_PRODUCTS_LOADING_STATE });
    } else {
      yield* put({
        type: FETCH_PRODUCT_LIST.FAILURE,
        message: "Something went wrong!!",
        payload: { totalPagesFetched },
      });
    }
    if (isLastPage === true) {
      yield* put({ type: FETCH_PRODUCT_LIST.STOP });
    }
  } catch (e: any) {
    yield* put({ type: FETCH_PRODUCT_LIST.FAILURE, message: e.message });
  }
}

function* getProductsColorData(
  action: LoadProductsFromCategoryAction,
  productIds: string,
) {
  try {
    const actionType = FETCH_PRODUCTS_COLORS;
    const constName = Object.keys({ FETCH_PRODUCTS_COLORS })[0].toString();
    const endpoint = acquireEndpoint(
      constName,
      productIds,
      action.payload?.isRefreshingAllProducts ? "true" : "false",
    );
    const headersObj = {
      "x-store-id": action.payload?.storeId,
      "x-locale-code": action.payload?.localeCode || "default",
    };
    const t0 = Date.now();
    yield* call(
      callApi,
      actionType,
      getData,
      action.payload,
      endpoint,
      headersObj,
    );
    const t1 = Date.now();
    recordTime(constName, t0, t1);
  } catch (error: any) {
    console.log("error", error);
  }
}

function* fetchProductsColorDataHandler(
  action: LoadProductsFromCategoryAction,
) {
  const productIds = action.payload.productIds;
  if (productIds && Array.isArray(productIds) && productIds.length > 0) {
    const commaSeperatedProductIds = productIds.join(",");
    yield* call(getProductsColorData, action, commaSeperatedProductIds);
  }
}

function* updateProductSequence(action: UpdateProductListSequenceAction) {
  let actionType = UPDATE_PRODUCT_LIST_SEQUENCE;
  const categoryId = action.payload.categoryId;
  const productSequences = action.payload.productSequences;
  const storeId = yield* select(selectCurrentStoreId);
  const catalogId = action.payload.catalogId;
  const constName = Object.keys({ UPDATE_PRODUCT_LIST_SEQUENCE })[0].toString();
  const localeCode = yield* select(selectCurrentLocale);

  const headersObj = {
    "x-store-id": storeId,
    "x-catalog-id": catalogId,
    "x-locale-code": localeCode || "default",
    "x-currency-code": "USD",
  };

  try {
    for (const item of productSequences) {
      const endpoint = acquireEndpoint(constName, categoryId, item.productId);
      const payload = {
        productId: item.productId,
        sequence: item.sequence,
        categoryId: categoryId,
      };

      const result = yield callApi(
        actionType,
        putData,
        payload,
        endpoint,
        headersObj,
      );
      /**
       * TODO : Add success and error handling
       */
      if (result) {
        if (result.type === actionType.SUCCESS) {
          if (
            result.payload.data &&
            result.payload.data.insert_SyncLog.affected_rows
          ) {
          }
        }
      }
    }
    yield* put({
      type: UPDATE_PRODUCT_LIST_SEQUENCE_MODE,
      sequenceMode: SEQUENCE_MODE_TYPE.VIEW,
    });
  } catch (e: any) {
    console.error(e);
    yield* put({ type: actionType.FAILURE, message: e.message });
  }
}

function* updateProductSequenceAsynchronously(
  action: UpdateProductSequenceAction,
) {
  yield* put({
    type: UPDATE_PRODUCT_SEQUENCE_LIST_ASYNC.REQUEST,
    payload: { categoryId: action.payload.categoryId },
    meta: { savePayload: action.payload },
  } as any);
  let actionType = UPDATE_PRODUCT_SEQUENCE_LIST_ASYNC;
  try {
    const categoryId = action.payload.categoryId;
    const catalogId = yield* select(selectCurrentCatalogId);
    const localeCode = yield* select(selectCurrentLocale);
    const storeId = yield* select(selectCurrentStoreId);
    const unmanagedProductIds = action.payload.unmanagedProductIds;
    const userId = getUserId();
    const userName = getUserName();
    const constName = Object.keys({
      UPDATE_PRODUCT_SEQUENCE_LIST_ASYNC,
    })[0].toString();
    const headersObj = {
      "x-store-id": storeId,
      "x-catalog-id": catalogId,
      "x-locale-code": localeCode || "default",
      "x-user-id": userId,
      "x-user-name": userName,
    };
    const payload = {
      categoryId,
      productIds: action.payload.productIds,
      unmanagedProductIds,
    };
    const endpoint = acquireEndpoint(constName, categoryId);
    const optionsObj = {
      showGenericError: false,
      meta: { categoryId, savePayload: action.payload },
    };
    const response = yield* call(
      callApi,
      actionType,
      putData,
      payload,
      endpoint,
      headersObj,
      optionsObj,
    );
    if (response && response.type === actionType.FAILURE) {
      yield* put(
        addGlobalAlertState({
          alertsProps: [
            {
              descriptor: {
                id: "productListOperations.updateProductSequenceFailure",
                defaultMessage:
                  "Failed to update product sequences, please try after sometime.",
              },
              severity: "error",
              variant: "standard",
            },
          ],
        }),
      );
    }
  } catch (e: any) {
    console.error(e);
    yield* put({
      type: actionType.FAILURE,
      payload: { categoryId: action.payload.categoryId },
      meta: { savePayload: action.payload },
    } as any);
    yield* put(
      addGlobalAlertState({
        alertsProps: [
          {
            descriptor: {
              id: "productListOperations.updateProductSequenceFailure",
              defaultMessage:
                "Failed to update product sequences, please try again after some time.",
            },
            severity: "error",
            variant: "standard",
          },
        ],
      }),
    );
  }
}

function* updateProductSequenceFn(action: UpdateProductSequenceAction) {
  yield* call(updateProductSequenceAsynchronously, action);
}

function* getProductSequenceFn(action: GetProductSequenceAction) {
  const actionType = GET_PRODUCT_SEQUENCE_LIST;
  try {
    const requestId = action.payload.requestId;
    const isUpdateFunctionInvoked = action.payload.isUpdateFunctionInvoked;
    const isFromProductDeleteOperation =
      action.payload.isFromProductDeleteOperation ?? false;
    const categoryId = action.payload.categoryId;
    const constName = Object.keys({ GET_PRODUCT_SEQUENCE_LIST })[0].toString();
    const serviceType = LOAD_ASYNC_REQUEST_SERVICE_URL;
    const endpoint = acquireEndpoint(constName, serviceType, requestId);
    const optionsObj = {
      showGenericError: false,
    };
    while (true) {
      const res = yield* call(
        callApi,
        actionType,
        getData,
        null,
        endpoint,
        {},
        optionsObj,
      );
      const result = res.payload;
      if (result && result?.response?.statusCode) {
        if (result?.response?.statusCode <= 204) {
          yield* put({
            type: GET_PRODUCT_SEQUENCE_LIST.DONE,
            payload: { categoryId },
          });
          if (
            isUpdateFunctionInvoked === true &&
            !isFromProductDeleteOperation
          ) {
            yield* put(
              addGlobalAlertState({
                alertsProps: [
                  {
                    descriptor: {
                      id: "productListOperations.updateProductSequenceSuccess",
                      defaultMessage: "Updated product sequences.",
                    },
                    severity: "success",
                    variant: "standard",
                  },
                ],
              }),
            );
          }
          break;
        } else if (result?.response?.statusCode >= 400) {
          yield* put({
            type: GET_PRODUCT_SEQUENCE_LIST.FAILURE,
            payload: { categoryId },
          });
          yield* put(
            addGlobalAlertState({
              alertsProps: [
                {
                  descriptor: {
                    id: "productListOperations.updateProductSequenceFailure",
                    defaultMessage:
                      "Failed to update product sequences, please try again after some time.",
                  },
                  severity: "error",
                  variant: "standard",
                },
              ],
            }),
          );
          break;
        }
      }
      yield* call(delay, 5000);
    }
  } catch (e: any) {
    console.error(e);
    yield* put({
      type: GET_PRODUCT_SEQUENCE_LIST.FAILURE,
      payload: { categoryId: action.payload.categoryId },
    });
    yield* put(
      addGlobalAlertState({
        alertsProps: [
          {
            descriptor: {
              id: "clipBoardArea.allCodesInvalid",
              defaultMessage:
                "Failed to update product sequences, please try again after some time.",
            },
            severity: "error",
            variant: "standard",
          },
        ],
      }),
    );
  }
}

function* updatePinnedProducts(action: UpdatePinnedProductsAction) {
  let actionType = UPDATE_PINNED_PRODUCTS;

  try {
    const storeId = action.payload.storeId;
    const catalogId = action.payload.catalogId;
    const categoryId = action.payload.categoryId;
    const productIds = action.payload.pinnedProducts;

    const syncLogInsertForDeleted = {
      tableName: "PinnedProducts",
      operationType: "DELETED",
      keyName1: "storeId",
      oldKeyValue1: storeId,
      newKeyValue1: storeId,
      keyName2: "catalogId",
      oldKeyValue2: catalogId,
      newKeyValue2: catalogId,
      keyName3: "categoryId",
      oldKeyValue3: categoryId,
      newKeyValue3: categoryId,
    };

    const syncLogInserts = [
      syncLogInsertForDeleted,
      ...productIds.map((productId) => {
        return {
          tableName: "PinnedProducts",
          operationType: "INSERTED",
          keyName1: "storeId",
          oldKeyValue1: storeId,
          newKeyValue1: storeId,
          keyName2: "catalogId",
          oldKeyValue2: catalogId,
          newKeyValue2: catalogId,
          keyName3: "categoryId",
          oldKeyValue3: categoryId,
          newKeyValue3: categoryId,
          keyName4: "productId",
          oldKeyValue4: productId,
          newKeyValue4: productId,
        };
      }),
    ];

    const query = {
      query: updateCategoryPinnedProductsQueryGenerator(productIds),
      variables: {
        storeId,
        catalogId,
        categoryId,
        syncLogInserts,
      },
    };
    const result: UpdatePinnedProductsResponse = yield callGraphQLApi(
      actionType,
      GraphQLService.query,
      query,
    );
    /**
     * TODO : Add success and error handling
     */
    if (result) {
      if (result.type === actionType.SUCCESS) {
        if (
          result.payload.data &&
          result.payload.data.insert_SyncLog.affected_rows
        ) {
        }
      }
      yield* put({
        type: UPDATE_PRODUCT_LIST_SEQUENCE_MODE,
        sequenceMode: SEQUENCE_MODE_TYPE.VIEW,
      });
    }
  } catch (e: any) {
    console.error(e);
    yield* put({ type: actionType.FAILURE, message: e.message });
  }
}

function* getSortingRulesList(action: LoadSortingRulesListFromSortAction) {
  try {
    const actionType = FETCH_SORTING_LIST;
    const constName = Object.keys({ FETCH_SORTING_LIST })[0].toString();
    const serviceType = BUSINESS_RULES_SERVICE_URL;
    const endpoint = acquireEndpoint(constName, serviceType);
    yield* call(callApi, actionType, getData, null, endpoint);
  } catch (error) {
    console.log("error", error);
  }
}

function* getSortedProductsListAsynchronously(
  action: LoadSortedProductsListFromSortAction,
) {
  try {
    yield* put(asyncSortProgressStart());
    const actionType = FETCH_SORTED_PRODUCTS_ASYNC;

    const storeId = yield* select(selectCurrentStoreId);
    const catalogId = yield* select(selectCurrentCatalogId);
    const constName = Object.keys({
      FETCH_SORTED_PRODUCTS_ASYNC,
    })[0].toString();
    const localeCode = yield* select(selectCurrentLocale);
    const categoryId = yield* select(selectCurrentCategory);
    const currencyCode = yield* select(selectCurrencyCode);
    const isUnmanagedProductsSupported =
      action.payload.isUnmanagedProductsSupported ?? false;
    const ruleId = action.payload.rule;
    const sortPeriod = action.payload.selectedSortPeriod;
    const timeZone = action.payload.timeZone;
    const serviceType = LOAD_ASYNC_REQUEST_SERVICE_URL;
    const lockedProducts = yield* select(
      selectLockedProducts,
      categoryId,
      catalogId,
    );
    const userId = getUserId();
    const userName = getUserName();
    const headersObj = {
      "x-user-id": userId,
      "x-user-name": userName,
    };
    const pinnedProducts = yield* select(selectPinnedProductIds);

    // Get productIds based on current mode (view/edit/search)
    const isFetchedBySearch = yield* select(selectIsFetchedBySearch);
    const sequenceMode = yield* select(selectProductListSequenceMode);

    let productIds: string[] = [];
    if (isFetchedBySearch) {
      const productsBySearch = yield* select(selectProductListBySearch);
      productIds = productsBySearch.map((product) => product.productId);
    } else if (sequenceMode === SEQUENCE_MODE_TYPE.VIEW) {
      const products = yield* select(selectProductListsFetched);
      productIds = products.map((product) => product.productId);
    } else {
      const editProducts = yield* select(selectProductListEditSequence);
      productIds = editProducts.map((product) => product.productId);
    }

    const payload = {
      storeId: storeId,
      catalogId: catalogId,
      localeCode: localeCode || "default",
      currencyCode: currencyCode || "USD",
      categoryId: categoryId,
      dateRange: sortPeriod,
      timezone: timeZone,
      productIds: productIds,
      lockedProductIds:
        lockedProducts?.map((lock) => {
          return {
            productId: lock.productId,
            position: lock.position,
          };
        }) || [],
      pinnedProductIds: pinnedProducts || [],
      ruleId,
      isUnmanagedProductsSupported,
    };
    const endpoint = acquireEndpoint(constName, serviceType, ruleId);
    const response = yield* call(
      callApi,
      actionType,
      postData,
      payload,
      endpoint,
      headersObj,
    );
    if (response && response.type === actionType.SUCCESS) {
      yield* call(
        getSortedProductsListFn,
        getSortedProductsList({
          requestId: response.payload.requestId,
          categoryId,
          catalogId,
          ruleId,
          isUnmanagedProductsSupported,
        }),
      );
    }
  } catch (error: any) {
    console.log("error", error);
    yield* put(asyncSortProgressStop());
  }
}

function* getUpdatedProductInfo(action) {
  try {
    const actionType =
      action.type === REFRESH_PRODUCT.REQUEST ? REFRESH_PRODUCT : FETCH_PRODUCT;
    const catalogId = action.payload.catalogId;
    const storeId = action.payload.storeId;
    const localeCode = action.payload.localeCode;
    const productId = action.payload.productId;
    const isFromLeadingImageChange =
      action.payload.isFromLeadingImageChange ?? "false";

    const constName = action.type.toString();

    const endpoint = acquireEndpoint(
      constName,
      productId,
      isFromLeadingImageChange,
    );
    const headersObj = {
      "x-locale-code": localeCode || "default",
      "x-currency-code": "USD",
      "x-store-id": storeId,
      "x-catalog-id": catalogId,
    };
    const response = yield* call(
      callApi,
      actionType,
      getData,
      action.payload,
      endpoint,
      headersObj,
    );
    if (
      response &&
      response.payload &&
      action.type === REFRESH_PRODUCT.REQUEST
    ) {
      yield* put({
        type: REFRESH_PRODUCT.SUCCESS,
        payload: {
          ...(response.payload as CategoryToProductData),
          findProductsModalCategoryId:
            action.payload.findProductsModalCategoryId,
        } as RefreshProductSuccessPayload,
      });

      const isProductHasColors =
        response.payload.cachedProduct?.product?.hasColors ?? false;
      if (isProductHasColors && isFromLeadingImageChange === "false") {
        yield* all([
          getUpdatedProductColorInfo(
            refreshProductColorFromList({ productId, localeCode, storeId }),
          ),
        ]);
      }
    } else if (
      response &&
      response.payload &&
      action.type === FETCH_PRODUCT.REQUEST
    ) {
      if (
        action.payload.isProductAddedFromClipBoard ||
        action.payload.isProductAddedFromVariationMgmt
      ) {
        const isProductHasColors =
          response.payload.cachedProduct?.product?.hasColors ?? false;
        if (isProductHasColors) {
          yield* all([
            getUpdatedProductColorInfo(
              refreshProductColorFromList({ productId, localeCode, storeId }),
            ),
          ]);
        }
      }
      //yield put({ type: FETCH_PRODUCT.SUCCESS, payload: response.payload as CategoryToProductData })
    } else if (action.type === REFRESH_PRODUCT.REQUEST) {
      yield* put({ type: REFRESH_PRODUCT.FAILURE, payload: action.payload });
    } else if (action.type === FETCH_PRODUCT.REQUEST) {
      yield* put({ type: FETCH_PRODUCT.FAILURE, payload: action.payload });
    }
  } catch (e: any) {
    console.error(e, e.message);
    yield* put({ type: REFRESH_PRODUCT.FAILURE, payload: action.payload });
  }
}

const LOAD_CATEGORY_PRODUCTS_TIMER = "LOAD CATEGORY PRODUCTS";
function* getProductIdsFromCategory(
  action: ReturnType<typeof loadProductIdsFromCategory>,
) {
  try {
    // performance tuning knobs
    /**
     * The max number of productIds to fetch in a single request.
     */
    const PRODUCT_IDS_PAGESIZE = +(AppEnv.PRODUCT_LIST_PAGE_SIZE ?? 24);

    /**
     * The number of workers to fetch product details concurrently.
     */
    const PRODUCT_DETAILS_MAX_WORKERS = +(
      AppEnv.PRODUCT_DETAILS_MAX_WORKERS ?? 6
    );

    /**
     * The max number of product details to fetch in a single request
     */
    const PRODUCT_DETAILS_PAGESIZE = +(AppEnv.PRODUCT_DETAILS_PAGESIZE ?? 4);

    console.debug({
      PRODUCT_IDS_PAGESIZE,
      PRODUCT_DETAILS_PAGESIZE,
      PRODUCT_DETAILS_MAX_WORKERS,
    });

    console.time(LOAD_CATEGORY_PRODUCTS_TIMER);

    yield* put({ type: FETCH_PRODUCT_LIST.START });

    const actionType = FETCH_PRODUCT_IDS;
    const {
      categoryId,
      catalogId,
      storeId,
      localeCode,
      isRefreshingAllProducts,
      storeListIds,
    } = action.payload;

    if (localeCode === null) {
      yield* put(
        addGlobalAlertState({
          alertsProps: [
            {
              descriptor: {
                id: "productListOperations.localeRequired",
                defaultMessage: "Locale is required",
              },
              severity: "error",
              variant: "standard",
            },
          ],
        }),
      );
      return;
    }

    const headersObj = {
      "x-locale-code": localeCode,
      "x-currency-code": "USD",
      "x-store-id": storeId,
      "x-catalog-id": catalogId,
    };
    let next = action.payload?.next || "";
    let allProductIds: string[] = action.payload.productIds || []; // Start with initial productIds

    timers = {};

    const workChannel = yield* call(
      channel<LoadProductsFromCategoryAction | "END">,
    );
    const productBadgeChannel = yield* call(
      channel<LoadQueryBadgeAction | "END">,
    );

    // Create separate worker for badge processing
    const badgeWorker = yield* fork(function* () {
      while (true) {
        const action = yield* take(productBadgeChannel);
        if (action === "END") {
          break;
        }
        yield* call(fetchProductQueryProduct, action);
      }
    });

    // Create workers for product details (now without badge coupling)
    const tasks: Task[] = [];
    for (let i = 0; i < PRODUCT_DETAILS_MAX_WORKERS; i++) {
      const task = yield* fork(function* worker() {
        while (true) {
          const action = yield* take(workChannel);
          if (action === "END") {
            break;
          }
          yield* call(getProductsFromCategory, action);
        }
      });
      tasks.push(task);
    }

    // Update category tree product count
    yield* put(
      LoadCategoryDetailsById(catalogId, categoryId, localeCode, storeId),
    );

    const initialLoadContextId = `${categoryId}|${catalogId}|${storeId ?? ""}|${localeCode ?? ""}`;
    yield* put(setPrefetchContextId(initialLoadContextId));

    // Calculate first-page capacity up front so we can dispatch first-page details
    // immediately on the first ID response, in parallel with continued ID fetching.
    const contentSlots = yield* select(selectContentSlots);
    const firstPageContentSlotsCount =
      contentSlots?.filter((slot) => slot.position <= PRODUCT_IDS_PAGESIZE).length ?? 0;
    const pageProductIdsCount = PRODUCT_IDS_PAGESIZE - firstPageContentSlotsCount;

    let totalPagesFetched = 0;
    let pageProductIds: string[] = [];
    let firstPageDispatched = false;
    let badgeTask: Task | null = null;

    while (true) {
      const constName = FETCH_PRODUCT_IDS.REQUEST.toString();
      const opts: Record<string, string | number> = {
        count: PRODUCT_IDS_PAGESIZE,
      };
      if (next) {
        opts.next = next;
      }
      const endpoint = acquireEndpoint(constName, categoryId, opts);

      // Call product ids API
      const t0 = Date.now();
      const result = yield* call(
        callApi,
        actionType,
        getData,
        null,
        endpoint,
        headersObj,
      );
      const t1 = Date.now();

      if (result !== null) {
        recordTime(constName, t0, t1);
      }

      if (result?.payload) {
        const productIds = result.payload.productIds;

        // Accumulate product IDs
        allProductIds = [...allProductIds, ...productIds];

        // On the very first response, dispatch first-page detail chunks to the
        // worker pool and start badge loading in parallel — workers process
        // first-page products while subsequent ID pages keep fetching.
        if (!firstPageDispatched) {
          firstPageDispatched = true;
          pageProductIds = allProductIds.slice(0, pageProductIdsCount);

          let chunks = Math.ceil(pageProductIds.length / PRODUCT_DETAILS_PAGESIZE);
          let idx = 0;
          while (chunks !== 0) {
            chunks--;
            totalPagesFetched += 1;
            const productIdsChunk = pageProductIds.slice(
              idx,
              idx + PRODUCT_DETAILS_PAGESIZE,
            );
            yield* put(workChannel, {
              type: LOAD_PRODUCT_LIST,
              payload: {
                productIds: productIdsChunk,
                catalogId,
                storeId,
                localeCode,
                categoryId,
                totalPagesFetched,
                storeListIds,
                isRefreshingAllProducts,
                pageProductIds,
                isLastPage: chunks === 0,
              },
            });
            idx += PRODUCT_DETAILS_PAGESIZE;
          }

          badgeTask = yield* fork(loadBadgesForProducts, pageProductIds);
        }

        // Check if there are more product IDs to load
        if (result.payload.next) {
          next = result.payload.next;
        } else {
          break; // Exit the loop if there's no more data
        }
      } else {
        yield* put({
          type: FETCH_PRODUCT_IDS.FAILURE,
        });
        break; // Exit the loop if there's no data
      }
    }

    // Dispatch chunks for the remaining IDs (everything past the first page —
    // first-page chunks were already pushed to workers above).
    const remainingIds = allProductIds.slice(pageProductIdsCount);
    let numberOfAPIcallsInChunks = Math.ceil(
      remainingIds.length / PRODUCT_DETAILS_PAGESIZE,
    );
    let currentIndex = 0;
    while (numberOfAPIcallsInChunks !== 0) {
      numberOfAPIcallsInChunks--;
      totalPagesFetched += 1;
      const productIdsChunk = remainingIds.slice(
        currentIndex,
        currentIndex + PRODUCT_DETAILS_PAGESIZE,
      );

      yield* put(workChannel, {
        type: LOAD_PRODUCT_LIST,
        payload: {
          productIds: productIdsChunk,
          catalogId,
          storeId,
          localeCode,
          categoryId,
          totalPagesFetched,
          storeListIds,
          isRefreshingAllProducts,
          pageProductIds: productIdsChunk,
          isLastPage: false,
        },
      });

      currentIndex += PRODUCT_DETAILS_PAGESIZE;
    }

    if (allProductIds.length > 0 && !action.payload.productIds) {
      yield* call(getOutOfPositionProducts, {
        payload: {
          productsList: allProductIds,
        },
      });
    }

    // Stop workers
    for (let i = 0; i < PRODUCT_DETAILS_MAX_WORKERS; i++) {
      yield* put(workChannel, "END");
    }
    yield* put(productBadgeChannel, "END");

    // Wait for all workers and the parallel badge fetch to finish
    const allTasks: Task[] = [...tasks, badgeWorker];
    if (badgeTask) allTasks.push(badgeTask);
    yield* join(allTasks);

    yield* put({
      type: FETCH_PRODUCT_DETAILS_PER_PAGE.SUCCESS,
      payload: {
        page: 1,
      },
    });

    if (!action.payload.productIds && allProductIds.length > pageProductIdsCount) {
      const remainingProductIds = allProductIds.slice(pageProductIdsCount);
      // The prefetch saga's eventual PREFETCH_REMAINING_PAGES.SUCCESS will
      // clear `prefetchContextId` (set at the top of this saga) via the
      // reducer, returning the Heat Map's `isPrefetching` signal to false.
      yield* put(
        prefetchRemainingPages({
          categoryId,
          catalogId,
          storeId,
          localeCode,
          pageSize: PRODUCT_IDS_PAGESIZE,
          remainingProductIds,
          requestContextId: `${categoryId}|${catalogId}|${storeId ?? ""}|${localeCode ?? ""}`,
        }),
      );
    } else {
      yield* put(setPrefetchContextId(null));
    }

    // log performance metrics
    console.timeEnd(LOAD_CATEGORY_PRODUCTS_TIMER);
    logTimers();

    // log fetch counts
    const products: ReturnType<typeof selectProducts> =
      yield* select(selectProducts);
    const productsLoaded = Object.keys(products).length;
    const total: ReturnType<typeof selectTotal> = yield* select(selectTotal);
    const productsWithColor = Object.values(products).filter(
      (p) => p.hasColors === true,
    ).length;
    const productColors: ReturnType<typeof selectProductColors> =
      yield* select(selectProductColors);
    const productColorsLoaded = Object.keys(productColors).length;
    console.debug({
      productsLoaded,
      total,
      productsWithColor,
      productColorsLoaded,
    });

    timers = null;
  } catch (e: any) {
    yield* put({ type: FETCH_PRODUCT_IDS.FAILURE, message: e.message });
  } finally {
    yield* put({ type: FETCH_PRODUCT_LIST.STOP });
  }
}

function* getPreviousProductIdsFromCategory(
  action: ReturnType<typeof loadPreviousProductIdsFromCategory>,
) {
  try {
    const actionType = FETCH_PREV_PRODUCT_IDS;
    const categoryId = action.payload.categoryId;
    const catalogId = action.payload.catalogId;
    const storeId = action.payload.storeId;
    const localeCode = action.payload.localeCode;
    const isRefreshingAllProducts = action.payload.isRefreshingAllProducts;
    const constName = FETCH_PRODUCT_IDS.REQUEST.toString();
    const headersObj = {
      "x-locale-code": localeCode || "default",
      "x-currency-code": "USD",
      "x-store-id": storeId,
      "x-catalog-id": catalogId,
    };
    const storeListIds = action.payload.storeListIds;
    let next = Number(action.payload?.next) ?? 0;
    let nextCheck = 0;
    if (action.payload?.next && action.payload?.count) {
      nextCheck = Number(action.payload?.next) % action.payload?.count;
      if (nextCheck > 0) {
        next -= nextCheck;
      }
    }
    const endpoint = acquireEndpoint(constName, categoryId, String(next));
    const result = !action.payload.productIds
      ? yield* call(callApi, actionType, getData, null, endpoint, headersObj)
      : null;
    if ((result && result.payload) || action.payload.productIds) {
      const productIds =
        result?.payload?.productIds || action.payload.productIds;
      const productCount = productIds.length;
      let totalPagesFetched = 0;
      let numberOfAPIcallsInchunks = Math.ceil(productCount / 4); // considering calling 4 items at a time;
      let currentIndex = 0;

      while (numberOfAPIcallsInchunks !== 0) {
        numberOfAPIcallsInchunks--;
        totalPagesFetched += 1;
        const productIdsChunk = productIds.slice(
          currentIndex,
          currentIndex + 4,
        );
        yield* put({
          type: LOAD_PRODUCT_LIST,
          payload: {
            productIds: productIdsChunk,
            catalogId,
            storeId,
            localeCode,
            categoryId,
            totalPagesFetched,
            storeListIds,
            isRefreshingAllProducts,
          },
        });
        currentIndex = currentIndex + 4;
      }
    } else {
      yield* put({ type: FETCH_PRODUCT_IDS.FAILURE });
    }
  } catch (e: any) {
    yield* put({ type: FETCH_PRODUCT_IDS.FAILURE, message: e.message });
  }
}

function* getNextProductIdsFromCategory(
  action: ReturnType<typeof loadNextProductIdsFromCategory>,
) {
  try {
    const actionType = FETCH_PREV_PRODUCT_IDS;
    const categoryId = action.payload.categoryId;
    const catalogId = action.payload.catalogId;
    const storeId = action.payload.storeId;
    const localeCode = action.payload.localeCode;
    const isRefreshingAllProducts = action.payload.isRefreshingAllProducts;
    const constName = FETCH_PRODUCT_IDS.REQUEST.toString();
    const headersObj = {
      "x-locale-code": localeCode || "default",
      "x-currency-code": "USD",
      "x-store-id": storeId,
      "x-catalog-id": catalogId,
    };
    const storeListIds = action.payload.storeListIds;
    const next = action.payload?.next || "";
    const endpoint = acquireEndpoint(constName, categoryId, next);

    const result = !action.payload.productIds
      ? yield* call(callApi, actionType, getData, null, endpoint, headersObj)
      : null;
    if ((result && result.payload) || action.payload.productIds) {
      const productIds =
        result?.payload?.productIds || action.payload.productIds;
      const productCount = productIds.length;
      let totalPagesFetched = 0;
      let numberOfAPIcallsInchunks = Math.ceil(productCount / 4); // considering calling 4 items at a time;
      let currentIndex = 0;

      while (numberOfAPIcallsInchunks !== 0) {
        numberOfAPIcallsInchunks--;
        totalPagesFetched += 1;
        const productIdsChunk = productIds.slice(
          currentIndex,
          currentIndex + 4,
        );
        yield* put({
          type: LOAD_PRODUCT_LIST,
          payload: {
            productIds: productIdsChunk,
            catalogId,
            storeId,
            localeCode,
            categoryId,
            totalPagesFetched,
            storeListIds,
            isRefreshingAllProducts,
          },
        });
        currentIndex = currentIndex + 4;
      }
    } else {
      yield* put({ type: FETCH_PRODUCT_IDS.FAILURE });
    }
  } catch (e: any) {
    yield* put({ type: FETCH_PRODUCT_IDS.FAILURE, message: e.message });
  }
}

function* getUpdatedProductColorInfo(action) {
  try {
    const actionType = REFRESH_PRODUCT_COLOR;
    const storeId = action.payload.storeId;
    const localeCode = action.payload.localeCode;
    const productId = action.payload.productId;
    const isFromColorManagementChange =
      action.payload.isFromColorManagementChange ?? "false";
    const constName = action.type.toString();

    const endpoint = acquireEndpoint(
      constName,
      productId,
      isFromColorManagementChange,
    );
    const headersObj = {
      "x-locale-code": localeCode || "default",
      "x-store-id": storeId,
    };
    const response = yield* call(
      callApi,
      actionType,
      getData,
      action.payload,
      endpoint,
      headersObj,
    );
    if (
      response &&
      response.payload &&
      action.type === REFRESH_PRODUCT_COLOR.SUCCESS
    ) {
      yield* put(createRefreshProductColorAction(response.payload));
    }
  } catch (e: any) {
    console.error(e, e.message);
    yield* put({
      type: REFRESH_PRODUCT_COLOR.FAILURE,
      payload: action.payload,
    });
  }
}

function* getWatchedProductList() {
  try {
    const actionType = FETCH_WATCHED_PRODUCT_LIST;
    const constName = Object.keys({ FETCH_WATCHED_PRODUCT_LIST })[0].toString();
    const email = yield* select(getUserEmail);
    const endpoint = acquireEndpoint(constName, email);
    yield* call(callApi, actionType, getData, null, endpoint);
  } catch (error: any) {
    console.log("error", error);
  }
}

function* addProductToWatchList(action: watchProductAction) {
  try {
    const actionType = ADD_PRODUCT_TO_WATCH_LIST;
    const constName = Object.keys({ ADD_PRODUCT_TO_WATCH_LIST })[0].toString();
    const endpoint = acquireEndpoint(constName);
    yield* call(callApi, actionType, postData, action.payload, endpoint);
  } catch (error: any) {
    console.log("error", error);
  }
}

function* removeProductFromWatchList(action: unWatchProductAction) {
  try {
    const actionType = REMOVE_PRODUCT_FROM_WATCH_LIST;
    const constName = Object.keys({
      REMOVE_PRODUCT_FROM_WATCH_LIST,
    })[0].toString();

    const endpoint = acquireEndpoint(constName);
    yield* call(callApi, actionType, postData, action.payload, endpoint);
  } catch (error: any) {
    console.log("error", error);
  }
}

function* lockProduct(action: LockProductAction) {
  try {
    const actionType = LOCK_PRODUCT;
    const constName = Object.keys({ LOCK_PRODUCT })[0].toString();
    const { lockedProducts } = action.payload;
    const categoryId = yield* select(selectCurrentCategory);
    const catalogId = yield* select(selectCurrentCatalogId);
    const serviceType = LOAD_PRODUCT_POSITION_SERVICE_URL;
    // Create an array of lock operations to run in parallel
    const lockOperations = lockedProducts?.map(({ productId, position }) => {
      const endpoint = acquireEndpoint(
        constName,
        serviceType,
        catalogId,
        categoryId,
        position,
      );

      return call(callApi, actionType, putData, { productId }, endpoint, {});
    });

    // Execute all lock operations in parallel
    const responses = yield* all(lockOperations);

    // Process successful locks and dispatch completion actions
    const successfulLocks = responses
      ?.map((response, index) => {
        if (response?.type === actionType.SUCCESS) {
          const { productId, position } = lockedProducts[index];
          return {
            catalogId,
            categoryId,
            position,
            productId,
          };
        }
        return null;
      })
      ?.filter(Boolean) as LocksInCategory[];

    if (successfulLocks.length > 0) {
      for (const lock of successfulLocks) {
        yield* put(lockProductCompleted(lock));
      }
    }
  } catch (error: any) {
    console.log("error", error);
    yield* put({ type: LOCK_PRODUCT.FAILURE, payload: action.payload });
  }
}

function* unLockProduct(action: UnLockProductAction) {
  try {
    const actionType = UNLOCK_PRODUCT;
    const constName = Object.keys({ UNLOCK_PRODUCT })[0].toString();
    const { unlockedProducts } = action.payload;
    const categoryId = yield* select(selectCurrentCategory);
    const catalogId = yield* select(selectCurrentCatalogId);
    const serviceType = LOAD_PRODUCT_POSITION_SERVICE_URL;
    const unlockOperations = unlockedProducts?.map(({ position }) => {
      const endpoint = acquireEndpoint(
        constName,
        serviceType,
        catalogId,
        categoryId,
        position,
      );
      return call(callApi, actionType, deleteData, null, endpoint, {});
    });
    const responses = yield* all(unlockOperations);
    const successfulUnlocks = responses
      ?.map((response, index) => {
        if (response?.type === actionType.SUCCESS) {
          const { position, productId } = unlockedProducts[index];
          return {
            catalogId,
            categoryId,
            position,
            productId,
          };
        }
        return null;
      })
      ?.filter(Boolean) as LocksInCategory[];
    if (successfulUnlocks.length > 0) {
      for (const unlock of successfulUnlocks) {
        yield* put(unlockProductCompleted(unlock));
      }
    }
  } catch (error: any) {
    console.log("error", error);
    yield* put({ type: UNLOCK_PRODUCT.FAILURE, payload: action.payload });
  }
}

function* getLocksForCategory(action: GetLocksInCategoryAction) {
  try {
    const actionType = FETCH_LOCKS_FOR_CATEGORY;
    const constName = Object.keys({ FETCH_LOCKS_FOR_CATEGORY })[0].toString();
    const { catalogId, categoryId } = action.payload;
    const serviceType = LOAD_PRODUCT_POSITION_SERVICE_URL;
    const endpoint = acquireEndpoint(
      constName,
      serviceType,
      catalogId,
      categoryId,
    );
    yield* call(callApi, actionType, getData, null, endpoint, {});
  } catch (error: any) {
    console.log("error", error);
    yield* put({ type: FETCH_LOCKS_FOR_CATEGORY.FAILURE });
  }
}

function* getContentSlots(action: getContentSlotsAction) {
  try {
    const actionType = GET_CONTENT_SLOTS;
    const constName = Object.keys({ GET_CONTENT_SLOTS })[0].toString();
    const { catalogId, categoryId, storeId } = action.payload;
    const serviceType = LOAD_CONTENT_SLOTS_SERVICE_URL;
    const endpoint = acquireEndpoint(
      constName,
      serviceType,
      storeId,
      catalogId,
      categoryId,
    );
    yield* call(callApi, actionType, getData, null, endpoint, {});
  } catch (error: any) {
    console.log("error", error);
    yield* put({ type: GET_CONTENT_SLOTS.FAILURE });
  }
}

function* addContentSlot(action: addContentSlotAction) {
  try {
    const actionType = ADD_CONTENT_SLOT;
    const constName = Object.keys({ ADD_CONTENT_SLOT })[0].toString();
    const serviceType = LOAD_CONTENT_SLOTS_SERVICE_URL;
    const endpoint = acquireEndpoint(constName, serviceType);
    const response = yield* call(
      callApi,
      actionType,
      postData,
      action.payload,
      endpoint,
    );
    if (response?.type === actionType.SUCCESS) {
      const payload = {
        slotId: response.payload.slotId,
        position: action.payload.position,
      };
      yield* put(updateContentSlotsState(payload));
    }
  } catch (error: any) {
    console.log("error", error);
    yield* put({ type: ADD_CONTENT_SLOT.FAILURE, payload: action.payload });
  }
}

function* updateContentSlot(action: updateContentSlotAction) {
  try {
    const actionType = UPDATE_CONTENT_SLOT;
    const constName = Object.keys({ UPDATE_CONTENT_SLOT })[0].toString();
    const serviceType = LOAD_CONTENT_SLOTS_SERVICE_URL;
    const { slotId, position } = action.payload;
    const endpoint = acquireEndpoint(constName, serviceType, slotId);
    const response = yield* call(
      callApi,
      actionType,
      putData,
      { position },
      endpoint,
    );
    if (response?.type === actionType.SUCCESS) {
      yield* put(updateContentSlotsState({ slotId, position }));
    }
  } catch (error: any) {
    console.log("error", error);
    yield* put({ type: UPDATE_CONTENT_SLOT.FAILURE, payload: action.payload });
  }
}

function* addUpdateContentSlot(action: addUpdateContentSlotAction) {
  try {
    yield* put({ type: SET_CONTENT_SLOT_LOADING });

    const { position } = action.payload;
    const contentSlots = yield* select(
      (state) => state.productList.contentSlots,
    );

    if (contentSlots?.length > 0) {
      const slotsToUpdate = contentSlots
        .filter((slot: ContentSlot) => slot.position >= position)
        .sort((a, b) => b.position - a.position);

      for (const slot of slotsToUpdate) {
        const updateAction = {
          type: UPDATE_CONTENT_SLOT.REQUEST,
          payload: {
            slotId: slot.slotId,
            position: slot.position + 1,
          },
        };
        yield* call(updateContentSlot, updateAction);
      }
    }

    yield* call(addContentSlot, action);
  } catch (error: any) {
    console.log("error", error);
  } finally {
    // Reset loading state regardless of success/failure
    yield* put({ type: RESET_CONTENT_SLOT_LOADING });
  }
}

function* deleteUpdateContentSlot(action: deleteUpdateContentSlotAction) {
  try {
    // Set loading state to true
    yield* put({ type: SET_CONTENT_SLOT_LOADING });

    const { slotId } = action.payload;
    const contentSlots = yield* select(
      (state) => state.productList.contentSlots,
    );

    const slotToDelete = contentSlots.find(
      (slot: ContentSlot) => slot.slotId === slotId,
    );

    if (!slotToDelete) {
      throw new Error("Content slot not found");
    }

    yield* call(deleteContentSlot, action);

    const slotsToUpdate = contentSlots
      .filter((slot: ContentSlot) => slot.position > slotToDelete.position)
      .sort((a, b) => a.position - b.position);

    for (const slot of slotsToUpdate) {
      const updateAction = {
        type: UPDATE_CONTENT_SLOT.REQUEST,
        payload: {
          slotId: slot.slotId,
          position: slot.position - 1,
        },
      };

      yield* call(updateContentSlot, updateAction);
    }
  } catch (error: any) {
    console.log("error", error);
  } finally {
    // Reset loading state regardless of success/failure
    yield* put({ type: RESET_CONTENT_SLOT_LOADING });
  }
}

function* deleteContentSlot(action: deleteContentSlotAction) {
  try {
    const actionType = DELETE_CONTENT_SLOT;
    const constName = Object.keys({ DELETE_CONTENT_SLOT })[0].toString();
    const { slotId } = action.payload;
    const serviceType = LOAD_CONTENT_SLOTS_SERVICE_URL;
    const endpoint = acquireEndpoint(constName, serviceType, slotId);
    const response = yield* call(
      callApi,
      actionType,
      deleteData,
      null,
      endpoint,
      {},
    );
    if (response?.type === actionType.SUCCESS) {
      yield* put(deleteContentSlotCompleted({ slotId }));
    }
  } catch (error: any) {
    console.log("error", error);
    yield* put({ type: DELETE_CONTENT_SLOT.FAILURE, payload: action.payload });
  }
}

function* getPinnedProducts(action: getPinnedProductsAction) {
  try {
    const actionType = GET_PINNED_PRODUCTS;
    const constName = Object.keys({ GET_PINNED_PRODUCTS })[0].toString();
    const serviceType = LOAD_PRODUCT_POSITION_SERVICE_URL;
    const { catalogId, categoryId } = action.payload;
    const endpoint = acquireEndpoint(
      constName,
      serviceType,
      catalogId,
      categoryId,
    );
    yield* call(callApi, actionType, getData, null, endpoint, {});
  } catch (error: any) {
    console.log("error", error);
    yield* put({ type: GET_PINNED_PRODUCTS.FAILURE });
  }
}

function* setPinnedProducts(action: pinnedProductsAction) {
  try {
    const actionType = SET_PINNED_PRODUCTS;
    const constName = Object.keys({ SET_PINNED_PRODUCTS })[0].toString();
    const { catalogId, categoryId, pinnedProductIds, sortOption } =
      action.payload;
    const serviceType = LOAD_PRODUCT_POSITION_SERVICE_URL;
    const endpoint = acquireEndpoint(
      constName,
      serviceType,
      catalogId,
      categoryId,
    );
    yield* call(
      callApi,
      actionType,
      putData,
      { pinnedProductIds, sortOption },
      endpoint,
    );
  } catch (error: any) {
    console.log("error", error);
    yield* put({ type: SET_PINNED_PRODUCTS.FAILURE, payload: action.payload });
  }
}

function* getOutOfPositionProducts(action) {
  try {
    const { productsList } = action.payload;
    const categoryId = yield* select(selectCurrentCategory);
    const catalogId = yield* select(selectCurrentCatalogId);
    const lockedProductsInCategory = yield* select(
      selectLockedProducts,
      categoryId,
      catalogId,
    );
    const lockedProductsOutOfPosition = productsList.filter(
      (productId: string, currentIndex: number) => {
        // Find if this product is locked
        const lockedProduct = lockedProductsInCategory.find(
          (lock) => lock.productId === productId,
        );

        // If product is locked, check if its current position matches locked position
        return lockedProduct && currentIndex + 1 !== lockedProduct.position;
      },
    );
    const pinnedProducts = yield* select(selectPinnedProductIds);
    const updatedPinnedProducts = pinnedProducts.filter(
      (productId) => productId !== "",
    );
    const pinnedProductsOutOfPosition = getPinnedProductsOutOfPosition(
      productsList,
      updatedPinnedProducts,
      lockedProductsInCategory,
      lockedProductsOutOfPosition,
    );
    if (
      pinnedProductsOutOfPosition.length > 0 ||
      lockedProductsOutOfPosition.length > 0
    ) {
      yield* put(
        setModalState(ConfirmOutOfPositionProductsModalId, true, {
          pinnedProducts: pinnedProductsOutOfPosition,
          lockedProducts: lockedProductsOutOfPosition,
        }),
      );
    }
  } catch (error: any) {
    console.log("error", error);
  }
}

function* discardOutOfPositionProducts(
  action: DiscardOutOfPositionProductsAction,
) {
  try {
    const {
      catalogId,
      categoryId,
      pinnedProductIds,
      sortOption,
      unlockedProducts,
      isPinnedProductsOutOfPosition,
      isProductsOutsidePinnedArea,
    } = action.payload;

    if (isPinnedProductsOutOfPosition) {
      yield* call(setPinnedProducts, {
        type: SET_PINNED_PRODUCTS.REQUEST,
        payload: {
          catalogId,
          categoryId,
          pinnedProductIds,
          sortOption,
        },
      });
    }

    if (unlockedProducts.length > 0) {
      yield* call(unLockProduct, {
        type: UNLOCK_PRODUCT.REQUEST,
        payload: {
          catalogId,
          categoryId,
          unlockedProducts,
        },
      });
    }
    if (isProductsOutsidePinnedArea || unlockedProducts.length > 0) {
      yield* put(
        addGlobalAlertState({
          alertsProps: [
            {
              descriptor: {
                id: "productListOperations.discardedOutOfPositionProducts",
                defaultMessage: "Discarded out-of-position locks and pins",
              },
              severity: "success",
              variant: "standard",
            },
          ],
        }),
      );
    }
  } catch (error: any) {
    console.log("error", error);
  }
}

function* getProductsColorAndBadgeDataOnPageChange(
  action: FetchPageColorBadgeDataAction,
) {
  try {
    yield* put({ type: FETCH_PRODUCT_LIST.START });
    const { products, page } = action.payload;
    let pageProductIds: string[] = [];

    if (products) {
      for (const product of products) {
        if (product.hasColors) {
          pageProductIds.push(product.productId);
        }
      }
    }

    if (pageProductIds.length > 0) {
      // Process in chunks of 4
      for (let i = 0; i < pageProductIds.length; i += 4) {
        const chunk = pageProductIds.slice(i, i + 4);
        const colorProductIds = chunk.join(",");
        const colorAction: LoadProductsFromCategoryAction = {
          type: LOAD_PRODUCT_LIST,
          payload: {
            storeId: action.payload.storeId,
            localeCode: action.payload.localeCode,
            catalogId: action.payload.catalogId,
            categoryId: action.payload.categoryId,
            productIds: chunk,
            storeListIds: [],
            isRefreshingAllProducts: false,
          },
        };
        yield* all([getProductsColorData(colorAction, colorProductIds)]);
      }
    }

    // Load badges using common function
    yield* call(loadBadgesForProducts, pageProductIds);

    yield* put({
      type: FETCH_PRODUCT_DETAILS_PER_PAGE.SUCCESS,
      payload: {
        page,
      },
    });
    yield* put({ type: FETCH_PRODUCT_LIST.STOP });
  } catch (e: any) {
    yield* put({ type: FETCH_PRODUCT_LIST.STOP });
    console.error("Error fetching page color data:", e);
  }
}

function* getProductDetailsPerPage(action: any) {
  try {
    yield* put({ type: FETCH_PRODUCT_LIST.START });
    // performance tuning knobs
    /**
     * The max number of productIds to fetch in a single request.
     */
    const PRODUCT_IDS_PAGESIZE = +(AppEnv.PRODUCT_LIST_PAGE_SIZE ?? 24);

    /**
     * The number of workers to fetch product details concurrently.
     */
    const PRODUCT_DETAILS_MAX_WORKERS = +(
      AppEnv.PRODUCT_DETAILS_MAX_WORKERS ?? 6
    );

    /**
     * The max number of product details to fetch in a single request
     */
    const PRODUCT_DETAILS_PAGESIZE = +(AppEnv.PRODUCT_DETAILS_PAGESIZE ?? 4);

    console.debug({
      PRODUCT_IDS_PAGESIZE,
      PRODUCT_DETAILS_PAGESIZE,
      PRODUCT_DETAILS_MAX_WORKERS,
    });

    console.time(LOAD_CATEGORY_PRODUCTS_TIMER);

    const { categoryId, catalogId, storeId, localeCode } = action.payload;

    if (localeCode === null) {
      yield* put(
        addGlobalAlertState({
          alertsProps: [
            {
              descriptor: {
                id: "productListOperations.localeRequired",
                defaultMessage: "Locale is required",
              },
              severity: "error",
              variant: "standard",
            },
          ],
        }),
      );
      return;
    }

    const headersObj = {
      "x-locale-code": localeCode,
      "x-currency-code": "USD",
      "x-store-id": storeId,
      "x-catalog-id": catalogId,
    };
    let allProductIds: string[] = action.payload.productIds || []; // Start with initial productIds

    timers = {};

    const workChannel = yield* call(
      channel<LoadProductsFromCategoryAction | "END">,
    );
    const productBadgeChannel = yield* call(
      channel<LoadQueryBadgeAction | "END">,
    );

    // Create separate worker for badge processing
    const badgeWorker = yield* fork(function* () {
      while (true) {
        const action = yield* take(productBadgeChannel);
        if (action === "END") {
          break;
        }
        yield* call(fetchProductQueryProduct, action);
      }
    });

    // Create workers for product details (now without badge coupling)
    const tasks: Task[] = [];
    for (let i = 0; i < PRODUCT_DETAILS_MAX_WORKERS; i++) {
      const task = yield* fork(function* worker() {
        while (true) {
          const action = yield* take(workChannel);
          if (action === "END") {
            break;
          }
          yield* call(getProductsFromCategory, action);
        }
      });
      tasks.push(task);
    }

    let totalPagesFetched = 0;
    let pageProductIds: string[] = allProductIds;
    let badgeTask: Task | null = null;

    if (!action.payload.productIds) {
      const actionType = LOAD_INITIAL_PRODUCTS_DETAILS;
      const constName = LOAD_INITIAL_PRODUCTS_DETAILS.REQUEST.toString();
      // Update category tree product count
      yield* put(
        LoadCategoryDetailsById(catalogId, categoryId, localeCode, storeId),
      );

      // Calculate first-page capacity before the fetch loop so we can dispatch early
      const contentSlots = yield* select(selectContentSlots);
      const firstPageContentSlotsCount =
        contentSlots?.filter((slot) => slot.position <= PRODUCT_IDS_PAGESIZE).length ?? 0;
      const pageProductIdsCount = PRODUCT_IDS_PAGESIZE - firstPageContentSlotsCount;

      let next = action.payload?.next || "";
      let firstPageDispatched = false;
      let nextDispatchIdx = 0;
      const initialLoadContextId = `${categoryId}|${catalogId}|${storeId ?? ""}|${localeCode ?? ""}`;
    
      yield* put(setPrefetchContextId(initialLoadContextId));

      while (true) {
        const opts: Record<string, string | number> = {
          count: PRODUCT_IDS_PAGESIZE,
        };
        if (next) {
          opts.next = next;
        }
        const endpoint = acquireEndpoint(constName, categoryId, opts);

        // Call product ids API
        const t0 = Date.now();
        const result = yield* call(
          callApi,
          actionType,
          getData,
          null,
          endpoint,
          headersObj,
        );
        const t1 = Date.now();
        if (result !== null) {
          recordTime(constName, t0, t1);
        }
        if (result?.payload) {
          const fetchedProductIds =
            result.payload.results?.map((result) => result.product.productId) ??
            [];

          // Accumulate product IDs
          allProductIds = [...allProductIds, ...fetchedProductIds];
          if (result.payload.results) {
            yield* put(
              getInitialProductDetails({ results: result.payload.results }),
            );
          }

          // Dispatch first-page product details to workers immediately on the first
          // response, so workers start processing in parallel with continued page fetching.
          if (!firstPageDispatched) {
            firstPageDispatched = true;
            pageProductIds = allProductIds.slice(0, pageProductIdsCount);

            let chunks = Math.ceil(pageProductIds.length / PRODUCT_DETAILS_PAGESIZE);
            let idx = 0;
            while (chunks !== 0) {
              chunks--;
              totalPagesFetched += 1;
              const productIdsChunk = pageProductIds.slice(idx, idx + PRODUCT_DETAILS_PAGESIZE);
              yield* put(workChannel, {
                type: LOAD_PRODUCT_LIST,
                payload: {
                  productIds: productIdsChunk,
                  catalogId,
                  storeId,
                  localeCode,
                  categoryId,
                  totalPagesFetched,
                  storeListIds: [],
                  isRefreshingAllProducts: false,
                  pageProductIds,
                  isLastPage: chunks === 0,
                },
              });
              idx += PRODUCT_DETAILS_PAGESIZE;
            }
            nextDispatchIdx = pageProductIdsCount;

            // Fork badge loading to run in parallel with continued page fetching
            badgeTask = yield* fork(loadBadgesForProducts, pageProductIds);
          } else if (allProductIds.length > nextDispatchIdx) {
            const toDispatch = allProductIds.slice(nextDispatchIdx);
            for (let i = 0; i < toDispatch.length; i += PRODUCT_DETAILS_PAGESIZE) {
              totalPagesFetched += 1;
              const productIdsChunk = toDispatch.slice(
                i,
                i + PRODUCT_DETAILS_PAGESIZE,
              );
              yield* put(workChannel, {
                type: LOAD_PRODUCT_LIST,
                payload: {
                  productIds: productIdsChunk,
                  catalogId,
                  storeId,
                  localeCode,
                  categoryId,
                  totalPagesFetched,
                  storeListIds: [],
                  isRefreshingAllProducts: false,
                  pageProductIds: productIdsChunk,
                  isLastPage: false,
                },
              });
            }
            nextDispatchIdx = allProductIds.length;
          }

          // Check if there are more product IDs to load
          if (result.payload.next) {
            next = result.payload.next;
          } else {
            break; // Exit the loop if there's no more data
          }
        } else {
          yield* put({
            type: LOAD_INITIAL_PRODUCTS_DETAILS.FAILURE,
          });
          break; // Exit the loop if there's no data
        }
      }
    } else {
      // Product IDs provided directly — dispatch immediately
      if (action.payload?.page) {
        yield* put(setPageFetchStatus(action.payload.page, "loading"));
      }
      const requestContextId = action.payload?.requestContextId;
      let chunks = Math.ceil(pageProductIds.length / PRODUCT_DETAILS_PAGESIZE);
      let idx = 0;
      while (chunks !== 0) {
        chunks--;
        totalPagesFetched += 1;
        const productIdsChunk = pageProductIds.slice(idx, idx + PRODUCT_DETAILS_PAGESIZE);
        yield* put(workChannel, {
          type: LOAD_PRODUCT_LIST,
          payload: {
            productIds: productIdsChunk,
            catalogId,
            storeId,
            localeCode,
            categoryId,
            totalPagesFetched,
            storeListIds: [],
            isRefreshingAllProducts: false,
            pageProductIds,
            isLastPage: chunks === 0,
            requestContextId,
          },
        });
        idx += PRODUCT_DETAILS_PAGESIZE;
      }

      badgeTask = yield* fork(loadBadgesForProducts, pageProductIds);
    }

    // Check for out of position products
    if (allProductIds.length > 0 && !action.payload.productIds) {
      yield* call(getOutOfPositionProducts, {
        payload: {
          productsList: allProductIds,
        },
      });
    }

    // Stop workers
    for (let i = 0; i < PRODUCT_DETAILS_MAX_WORKERS; i++) {
      yield* put(workChannel, "END");
    }
    yield* put(productBadgeChannel, "END");

    // Wait for all workers and badge loading to finish
    const allTasks: Task[] = [...tasks, badgeWorker];
    if (badgeTask) allTasks.push(badgeTask);
    yield* join(allTasks);

    // For non-empty categories the worker already fired STOP; this second STOP is a harmless no-op.)
    yield* put({ type: FETCH_PRODUCT_LIST.STOP });

    // Dispatch success action to mark page as loaded
    yield* put({
      type: FETCH_PRODUCT_DETAILS_PER_PAGE.SUCCESS,
      payload: {
        page: action.payload.page,
      },
    });
    // SM4A-2618 — kick off background prefetch of every remaining product in
    // the category so the Heat Map modal reflects the full inventory on open.
    if (!action.payload.productIds) {
      const contentSlotsAfter = yield* select(selectContentSlots);
      const firstPageContentSlotsCount =
        contentSlotsAfter?.filter(
          (slot: ContentSlot) => slot.position <= PRODUCT_IDS_PAGESIZE,
        ).length ?? 0;
      const firstPageCount = PRODUCT_IDS_PAGESIZE - firstPageContentSlotsCount;
      const remainingProductIds = allProductIds.slice(firstPageCount);
      if (remainingProductIds.length > 0) {
        yield* put(
          prefetchRemainingPages({
            categoryId,
            catalogId,
            storeId,
            localeCode,
            pageSize: PRODUCT_IDS_PAGESIZE,
            remainingProductIds,
            requestContextId: `${categoryId}|${catalogId}|${storeId ?? ""}|${localeCode ?? ""}`,
          }),
        );
      } else {
        yield* put(setPrefetchContextId(null));
      }
    }

    // log performance metrics
    console.timeEnd(LOAD_CATEGORY_PRODUCTS_TIMER);
    logTimers();

    // log fetch counts
    const products: ReturnType<typeof selectProducts> =
      yield* select(selectProducts);
    const productsLoaded = Object.keys(products).length;
    const total: ReturnType<typeof selectTotal> = yield* select(selectTotal);
    const productsWithColor = Object.values(products).filter(
      (p) => p.hasColors === true,
    ).length;
    const productColors: ReturnType<typeof selectProductColors> =
      yield* select(selectProductColors);
    const productColorsLoaded = Object.keys(productColors).length;
    console.debug({
      productsLoaded,
      total,
      productsWithColor,
      productColorsLoaded,
    });

    timers = null;
  } catch (e: any) {
    console.error("Error fetching product details for page:", e);
    yield* put({
      type: FETCH_PRODUCT_DETAILS_PER_PAGE.FAILURE,
      message: e.message,
    });
    // Stop the product list loading on error
    yield* put({ type: FETCH_PRODUCT_LIST.STOP });
  }
}

function* updateSortedProductsPositionsSaga(
  action: UpdateSortedProductsPositionsAction,
) {
  const { promotedProducts, demotedProducts, categoryId, catalogId } =
    action.payload;

  const productList = yield* select(
    (state: AppState) => state.productList.editSequenceList,
  );
  const lockedProducts = yield* select(
    selectLockedProducts,
    categoryId,
    catalogId,
  );
  const pinnedProducts = yield* select(
    (state: AppState) => state.productList.pinnedProductIds,
  );
  const updatedLockedProductsInCategory = yield* select(
    selectUpdatedLocksInCategory,
    categoryId,
    catalogId,
  );

  // Get existing positioned products
  let positionedProductIds: string[] = productList
    .filter((product) => product.position !== undefined)
    .map((product) => product.productId);

  // Get locked and pinned product IDs (these should keep their positions)
  const lockedProductIds = new Set(
    lockedProducts?.map((lock) => lock.productId) || [],
  );
  const pinnedProductsSet = new Set(pinnedProducts || []);

  // Filter out demoted products that are locked or pinned (they keep positions)
  const updatedDemotedProducts = demotedProducts?.filter(
    (productId) =>
      !(lockedProductIds.has(productId) || pinnedProductsSet.has(productId)),
  );

  // Check if positioned and unpositioned areas exist
  const isPositionedAreaExists = productList.some(
    (product) => product.position !== undefined,
  );
  const isUnpositionedAreaExists = productList.some(
    (product) => product.position === undefined,
  );

  // Add promoted products to positioned list (if positioned area exists)
  if (isPositionedAreaExists && promotedProducts?.length > 0) {
    promotedProducts.forEach((productId) => {
      if (!positionedProductIds.includes(productId)) {
        positionedProductIds.push(productId);
      }
    });
  }

  // Handle demoted products
  if (updatedDemotedProducts && updatedDemotedProducts.length > 0) {
    if (!isUnpositionedAreaExists) {
      // If no unpositioned area exists, add demoted products to positioned list
      updatedDemotedProducts.forEach((productId) => {
        if (!positionedProductIds.includes(productId)) {
          positionedProductIds.push(productId);
        }
      });
    } else {
      // If unpositioned area exists, remove demoted products from positioned list
      positionedProductIds = positionedProductIds.filter(
        (productId) => !updatedDemotedProducts.includes(productId),
      );
    }
  }

  let updatedSequence = updateProductSequencePositions(
    productList,
    positionedProductIds,
  );

  // Handle undefined products and locked products
  const {
    updatedSequence: finalSequence,
    updatedPositionedIds,
    unlockActions,
  } = handleUndefinedProductsAndLocks(
    updatedSequence,
    positionedProductIds,
    updatedLockedProductsInCategory || [],
  );

  // Dispatch unlock actions for products whose positions have changed
  if (unlockActions.length > 0) {
    for (const unlockAction of unlockActions) {
      yield* put(setLockedUnlockedProducts(unlockAction));
    }
  }

  // Update final sequence with positions based on updated positioned IDs
  const finalUpdatedProductList = updateProductSequencePositions(
    finalSequence,
    updatedPositionedIds,
  );

  if (promotedProducts?.length > 0 || demotedProducts?.length > 0) {
    // Check if the actual product order changed
    const isProductsSequenceOrderChanged = finalUpdatedProductList.some(
      (product, index) => product.productId !== productList[index]?.productId,
    );

    // Update the product list in state
    yield* put(
      updateProductListInState({
        products: finalUpdatedProductList,
        isSaveAction: true,
      }),
    );

    // Only enable EDIT mode if the order actually changed
    if (isProductsSequenceOrderChanged) {
      yield* put(updateProductListSequenceMode(SEQUENCE_MODE_TYPE.EDIT));
    }
  }
}

function* loadCurrentPageSortedProductsDetails(action: {
  products: SortedProductScore[];
}) {
  const { products } = action;
  const contentSlots = yield* select(selectContentSlots);
  const currentPage = yield* select(selectCurrentPage);
  const sequenceMode = yield* select(selectProductListSequenceMode);
  const catalogId = yield* select(selectCurrentCatalogId);
  const storeId = yield* select(selectCurrentStoreId);
  const categoryId = yield* select(selectCurrentCategory);
  const localeCode = yield* select(selectCurrentLocale);
  const allProductColorsData = yield* select(selectProductColors);
  const allProductsData = yield* select(selectProducts);
  const pageSize = +(AppEnv.PRODUCT_LIST_PAGE_SIZE ?? 24);
  const isCategoryProductsV2Available = yield* select(
    selectIsCategoryProductsV2Available,
  );

  const sortedProductIds =
    products?.map((product: SortedProductScore) => product.productId) || [];

  const currentPageProductIds = getCurrentPageProductIds(
    contentSlots,
    currentPage,
    false,
    [],
    sequenceMode,
    [],
    [],
    sortedProductIds,
  );

  const productsNotLoaded = currentPageProductIds.filter((productId) => {
    const product = allProductsData[productId];
    return !product || !product.productDetailsLoaded;
  });
  const colorProductsNotLoaded = currentPageProductIds.filter((productId) => {
    const hasColors = allProductsData[productId].hasColors;
    if (hasColors) {
      const product = allProductColorsData[productId];
      return !product || !product.productColorDetailsLoaded;
    }
    return false;
  });
  // Only proceed if there are missing products to load
  if (productsNotLoaded.length > 0 && isCategoryProductsV2Available) {
    yield* call(getProductDetailsPerPage, {
      payload: {
        page: currentPage,
        catalogId: catalogId,
        storeId: storeId,
        categoryId: categoryId,
        localeCode: localeCode,
        productIds: productsNotLoaded,
        pageSize: pageSize,
      },
    });
  } else if (
    colorProductsNotLoaded.length > 0 &&
    !isCategoryProductsV2Available &&
    storeId != null
  ) {
    const productsNeedingColorData = colorProductsNotLoaded
      .map((productId) => allProductsData[productId])
      .filter((product) => product != null);

    const action: FetchPageColorBadgeDataAction = {
      type: FETCH_PAGE_COLOR_BADGE_DATA.REQUEST,
      payload: {
        page: currentPage,
        catalogId: catalogId,
        storeId: storeId,
        categoryId: categoryId,
        localeCode: localeCode,
        products: productsNeedingColorData,
        storeListIds: [],
      },
    };

    yield* call(getProductsColorAndBadgeDataOnPageChange, action);
  }
}

function* loadRemainingProductsSaga(action: LoadRemainingProductsAction) {
  try {
    const { categoryId, catalogId, storeId, localeCode, allProductIds } =
      action.payload;

    // Get current products state to check which are already loaded
    const products: ReturnType<typeof selectProducts> =
      yield* select(selectProducts);

    // Filter to only get products that are NOT loaded
    const remainingProductIds = allProductIds.filter(
      (productId) => !products[productId]?.productDetailsLoaded,
    );

    if (remainingProductIds.length === 0) {
      // Close modal if it was opened but no products to load
      yield* put(
        setRemainingProductsModal({
          isOpen: false,
          progress: 0,
          total: 0,
          loaded: 0,
        }),
      );
      return;
    }

    // Modal is already shown before saga starts, just ensure it's still open
    yield* put(
      setRemainingProductsModal({
        isOpen: true,
        progress: 0,
        total: remainingProductIds.length,
        loaded: 0,
      }),
    );

    // Performance tuning knobs
    const PRODUCT_DETAILS_MAX_WORKERS = +(
      AppEnv.PRODUCT_DETAILS_MAX_WORKERS ?? 6
    );
    const PRODUCT_DETAILS_PAGESIZE = +(AppEnv.PRODUCT_DETAILS_PAGESIZE ?? 4);

    const workChannel = yield* call(
      channel<LoadProductsFromCategoryAction | "END">,
    );
    const productBadgeChannel = yield* call(
      channel<LoadQueryBadgeAction | "END">,
    );

    // Create badge worker
    const badgeWorker = yield* fork(function* () {
      while (true) {
        const action = yield* take(productBadgeChannel);
        if (action === "END") {
          break;
        }
        yield* call(fetchProductQueryProduct, action);
      }
    });

    // Create workers for product details
    const tasks: Task[] = [];
    for (let i = 0; i < PRODUCT_DETAILS_MAX_WORKERS; i++) {
      const task = yield* fork(function* worker() {
        while (true) {
          const action = yield* take(workChannel);
          if (action === "END") {
            break;
          }
          yield* call(getProductsFromCategory, action);
        }
      });
      tasks.push(task);
    }

    // Load remaining products in chunks
    const numberOfAPIcallsInChunks = Math.ceil(
      remainingProductIds.length / PRODUCT_DETAILS_PAGESIZE,
    );
    let currentIndex = 0;
    let chunksRemaining = numberOfAPIcallsInChunks;

    // Fork a task to monitor product loading progress
    const progressMonitor = yield* fork(function* () {
      while (true) {
        // Check if cancelled
        const modalState = yield* select(selectRemainingProductsModal);
        if (modalState.isCancelled) {
          break;
        }

        // Wait for a product load success event or cancellation check
        // Use race to check cancellation periodically
        const result = yield* race({
          success: take(FETCH_PRODUCT_LIST.SUCCESS),
          cancelled: delay(200), // Check cancellation every 200ms
        });

        // Check if cancelled
        const cancelledState = yield* select(selectRemainingProductsModal);
        if (cancelledState.isCancelled) {
          break;
        }

        // Only update progress if we got a success event
        if (result.success) {
          // Small delay to allow reducer to update product state
          yield* delay(50);

          // Count how many remaining products are now loaded
          const allProducts = yield* select(selectProducts);
          const loadedCount = remainingProductIds.filter(
            (id) => allProducts[id]?.productDetailsLoaded,
          ).length;

          // Update progress based on actual products loaded
          const progress = Math.min(
            100,
            Math.round((loadedCount / remainingProductIds.length) * 100),
          );

          yield* put(
            setRemainingProductsModal({
              isOpen: true,
              progress,
              total: remainingProductIds.length,
              loaded: loadedCount,
            }),
          );

          // If all products are loaded, break
          if (loadedCount >= remainingProductIds.length) {
            break;
          }
        }
      }
    });

    // Send all chunks to workers
    while (chunksRemaining > 0 && currentIndex < remainingProductIds.length) {
      // Check if cancelled before sending each chunk
      const modalState = yield* select(selectRemainingProductsModal);
      if (modalState.isCancelled) {
        break;
      }

      const productIdsChunk = remainingProductIds.slice(
        currentIndex,
        currentIndex + PRODUCT_DETAILS_PAGESIZE,
      );

      const isLastPage =
        currentIndex + PRODUCT_DETAILS_PAGESIZE >= remainingProductIds.length;

      yield* put(workChannel, {
        type: LOAD_PRODUCT_LIST,
        payload: {
          productIds: productIdsChunk,
          catalogId,
          storeId: storeId || "",
          localeCode: localeCode || "",
          categoryId,
          totalPagesFetched: 0,
          storeListIds: [],
          isRefreshingAllProducts: false,
          pageProductIds: productIdsChunk,
          isLastPage,
        },
      });

      // Update counter based on actual chunk size
      const actualChunkSize = productIdsChunk.length;
      currentIndex += actualChunkSize;
      chunksRemaining--;
    }

    // Check if cancelled - if so, stop everything immediately
    const cancelledCheck = yield* select(selectRemainingProductsModal);
    if (cancelledCheck.isCancelled) {
      // Stop workers immediately by sending END to channels
      for (let i = 0; i < PRODUCT_DETAILS_MAX_WORKERS; i++) {
        yield* put(workChannel, "END");
      }
      yield* put(productBadgeChannel, "END");

      // Cancel all worker tasks to stop in-flight API calls
      for (const task of tasks) {
        yield* cancel(task);
      }
      yield* cancel(badgeWorker);

      // Cancel progress monitor
      yield* cancel(progressMonitor);

      // Load badges for products that were successfully loaded before cancellation (in background)
      yield* fork(loadBadgesForLoadedProducts, remainingProductIds);

      // Close modal immediately
      yield* put({
        type: LOAD_REMAINING_PRODUCTS.SUCCESS,
      });
      return;
    }

    // Stop workers normally
    for (let i = 0; i < PRODUCT_DETAILS_MAX_WORKERS; i++) {
      yield* put(workChannel, "END");
    }
    yield* put(productBadgeChannel, "END");

    // Wait for all workers to finish, but check for cancellation periodically
    const joinResult = yield* race({
      workers: join([...tasks, badgeWorker]),
      cancelled: (function* () {
        while (true) {
          const checkState = yield* select(selectRemainingProductsModal);
          if (checkState.isCancelled) {
            return true;
          }
          yield* delay(100);
        }
      })(),
    });

    // If cancelled during worker execution, cancel everything
    if (joinResult.cancelled) {
      // Cancel all worker tasks
      for (const task of tasks) {
        yield* cancel(task);
      }
      yield* cancel(badgeWorker);
      yield* cancel(progressMonitor);

      // Load badges for products that were successfully loaded before cancellation (in background)
      yield* fork(loadBadgesForLoadedProducts, remainingProductIds);

      // Close modal immediately
      yield* put({
        type: LOAD_REMAINING_PRODUCTS.SUCCESS,
      });
      return;
    }

    // Wait for progress monitor to finish (it will break when all products are loaded)
    const monitorResult = yield* race({
      monitor: join(progressMonitor),
      cancelled: (function* () {
        while (true) {
          const checkState = yield* select(selectRemainingProductsModal);
          if (checkState.isCancelled) {
            return true;
          }
          yield* delay(100);
        }
      })(),
    });

    // If cancelled during progress monitoring, close modal
    if (monitorResult.cancelled) {
      yield* cancel(progressMonitor);

      // Load badges for products that were successfully loaded before cancellation (in background)
      yield* fork(loadBadgesForLoadedProducts, remainingProductIds);

      yield* put({
        type: LOAD_REMAINING_PRODUCTS.SUCCESS,
      });
      return;
    }

    // Final check - ensure we show 100% and all products loaded
    const allProducts = yield* select(selectProducts);
    const finalLoadedCount = remainingProductIds.filter(
      (id) => allProducts[id]?.productDetailsLoaded,
    ).length;

    // Load colors for remaining products in the correct order (sequentially)
    // This ensures colors are loaded in product order, not chunk completion order
    const productsNeedingColors: string[] = [];
    for (const productId of remainingProductIds) {
      const product = allProducts[productId];
      if (product?.hasColors && product?.productDetailsLoaded) {
        const productColors = yield* select(selectProductColors);
        if (!productColors[productId]?.productColorDetailsLoaded) {
          productsNeedingColors.push(productId);
        }
      }
    }

    // Calculate total items to load (products + colors)
    const totalItemsToLoad =
      remainingProductIds.length + productsNeedingColors.length;
    let loadedItems = finalLoadedCount; // Start with loaded product details

    // Load colors sequentially in chunks to maintain order
    if (productsNeedingColors.length > 0) {
      const COLOR_CHUNK_SIZE = 4;
      for (let i = 0; i < productsNeedingColors.length; i += COLOR_CHUNK_SIZE) {
        // Check if cancelled before loading each color chunk
        const cancelCheck = yield* select(selectRemainingProductsModal);
        if (cancelCheck.isCancelled) {
          break;
        }

        const colorChunk = productsNeedingColors.slice(i, i + COLOR_CHUNK_SIZE);
        const colorProductIds = colorChunk.join(",");
        const colorAction: LoadProductsFromCategoryAction = {
          type: LOAD_PRODUCT_LIST,
          payload: {
            storeId: storeId || "",
            localeCode: localeCode || "",
            catalogId,
            categoryId,
            productIds: colorChunk,
            storeListIds: [],
            isRefreshingAllProducts: false,
          },
        };
        yield* call(getProductsColorData, colorAction, colorProductIds);

        // Update progress after each color chunk
        loadedItems += colorChunk.length;
        const progress = Math.min(
          100,
          Math.round((loadedItems / totalItemsToLoad) * 100),
        );

        yield* put(
          setRemainingProductsModal({
            isOpen: true,
            progress,
            total: remainingProductIds.length, // Keep total as product count for display
            loaded: finalLoadedCount, // Keep loaded as product count for display
          }),
        );
      }
    }

    yield* put(
      setRemainingProductsModal({
        isOpen: true,
        progress: 100,
        total: remainingProductIds.length,
        loaded: finalLoadedCount,
      }),
    );

    yield* put({
      type: LOAD_REMAINING_PRODUCTS.SUCCESS,
    });

    // Load badges for remaining products in background (after modal closes)
    yield* fork(loadBadgesForProducts, remainingProductIds);
  } catch (e: any) {
    console.error("Error loading remaining products:", e);
    yield* put({
      type: LOAD_REMAINING_PRODUCTS.FAILURE,
    });
  }
}

function* fetchInProgressRequestsSnapshotFn(
  action: FetchInProgressRequestsSnapshotAction,
) {
  const actionType = FETCH_IN_PROGRESS_REQUESTS_SNAPSHOT;
  try {
    const { accountId } = action.payload;
    const constName = Object.keys({
      FETCH_IN_PROGRESS_REQUESTS_SNAPSHOT,
    })[0].toString();
    const serviceType = LOAD_ASYNC_REQUEST_SERVICE_URL;

    // Calculate timestamp for 15 minutes ago to fetch recent requests
    const updatedSince = new Date(Date.now() - 15 * 60 * 1000).toISOString();
    const endpoint = acquireEndpoint(
      constName,
      serviceType,
      accountId,
      updatedSince,
    );
    const optionsObj = {
      showGenericError: false,
    };

    const response = yield* call(
      callApi,
      actionType,
      getData,
      null,
      endpoint,
      {},
      optionsObj,
    );

    // After snapshot is fetched, check for completed saves we missed due to disconnection
    // The snapshot API now returns all requests (IN_PROGRESS, SUCCEEDED, FAILED) updated in last 15 minutes
    if (response && response.type === actionType.SUCCESS) {
      const allRequests = response.payload?.requests || [];
      const state = yield* select();
      const pendingRequestIds =
        state.productList?.pendingCategorySaveRequestIds || {};

      // Find completed requests that we initiated but missed due to disconnection
      const completedRequests = allRequests.filter(
        (request: any) =>
          request.requestId in pendingRequestIds &&
          (request.status === "SUCCEEDED" || request.status === "FAILED"),
      );

      if (completedRequests.length > 0) {
        console.log(
          "🔄 Processing completed saves missed during disconnection",
          {
            count: completedRequests.length,
          },
        );

        for (const request of completedRequests) {
          const { requestId, status, response: requestResponse } = request;
          const categoryId = request.request?.params?.categoryId;

          if (!categoryId || !requestId) continue;

          const isSuccess = status === "SUCCEEDED";
          const errorMessage =
            !isSuccess && requestResponse?.body?.message
              ? requestResponse.body.message
              : undefined;

          console.log("📬 Processing missed save completion", {
            requestId,
            categoryId,
            status,
            isSuccess,
          });

          if (isSuccess) {
            yield* put(websocketCategorySaveCompleted(categoryId, requestId));
          } else {
            yield* put(
              websocketCategorySaveFailed(categoryId, requestId, errorMessage),
            );
          }
        }
      }
    }
  } catch (e: any) {
    yield* put({ type: actionType.FAILURE });
    console.error("Error fetching in-progress requests snapshot:", e);
  }
}

function* checkCategorySaveFn(action: CheckCategorySaveAction) {
  try {
    const { categoryId } = action.payload;
    const state = yield* select();
    const savingCategoryIds = state.productList?.savingCategoryIds ?? [];
    const isBeingSaved = savingCategoryIds.includes(categoryId);

    if (isBeingSaved) {
      // Show alert if category is being saved
      yield* put(
        addGlobalAlertState({
          alertsProps: [
            {
              descriptor: {
                id: "categorySelection.saveInProgress",
                defaultMessage: "Save In Progress",
              },
              severity: "warning",
              variant: "standard",
            },
          ],
        }),
      );
    }
  } catch (e: any) {
    console.error("Error checking category save:", e);
  }
}

/**
 * Handler for WebSocket category.save.started event
 * Shows alert to non-initiators who are currently viewing the category being saved
 */
function* handleCategorySaveStartedFn(
  action: WebSocketCategorySaveStartedAction,
) {
  try {
    const { categoryId } = action.payload || {};

    const state = yield* select();
    const currentCategoryId = yield* select(selectCurrentCategory);
    const currentUserInitiatedSaves =
      state.productList?.currentUserInitiatedSaves ?? [];
    const isCurrentUserSave = currentUserInitiatedSaves.includes(categoryId);

    if (currentCategoryId === categoryId && !isCurrentUserSave) {
      yield* put(
        addGlobalAlertState({
          alertsProps: [
            {
              descriptor: {
                id: "categorySelection.saveInProgress",
                defaultMessage: "Save In Progress",
              },
              severity: "warning",
              variant: "standard",
            },
          ],
        }),
      );
    }
  } catch (e: any) {
    console.error("Error handling category save started:", e);
  }
}

/**
 * Common function to show reload modal if the current user is viewing the specified category
 * This is called for both success and failure cases
 */
function* showReloadModalIfCurrentCategory(categoryId: string) {
  if (!categoryId) return;

  const currentCategoryId = yield* select(selectCurrentCategory);
  const isCurrentCategory = currentCategoryId === categoryId;

  // Show reload modal to ANY user currently viewing this category
  if (isCurrentCategory) {
    yield* put(
      setModalState("ReloadCategoryModal", true, {
        categoryId,
      }),
    );
  }
}

function* handleCategorySaveCompletedFn(
  action: WebSocketCategorySaveCompletedAction,
) {
  try {
    const { requestId, categoryId } = action.payload || {};
    const state = yield* select();
    const pendingCategorySaveRequestIds =
      state.productList?.pendingCategorySaveRequestIds || {};

    // Get the category ID that was saved
    const saveInfo = pendingCategorySaveRequestIds[requestId];
    const targetCategoryId = categoryId || saveInfo?.categoryId || "";

    if (!targetCategoryId) return;
    // Show reload modal to ANY user currently viewing this category (regardless of who saved)
    yield* call(showReloadModalIfCurrentCategory, targetCategoryId);

    // Only show toast and alert if this requestId was initiated by the current user
    if (saveInfo) {
      const categoryNames = yield* select(selectCategoryNamesByIds, [
        targetCategoryId,
      ]);
      const categoryName = categoryNames[0] || targetCategoryId || "";
      const message = `Save completed for category ${categoryName}.`;

      yield* put(
        addGlobalAlertState({
          alertsProps: [
            {
              descriptor: {
                id: "productListOperations.updateProductSequenceSuccess",
                defaultMessage: "Updated product sequences.",
              },
              severity: "success",
              variant: "standard",
            },
          ],
        }),
      );

      // Show success toast
      yield* put(
        showSnackbar({
          message,
          variant: "success",
          categoryId: targetCategoryId,
          key: `save-success-${requestId}`,
        }),
      );

      // Remove requestId from pendingCategorySaveRequestIds after processing
      yield* put(clearPendingSaveRequestId(requestId));
    }
  } catch (e: any) {
    console.error("Error handling category save completion:", e);
  }
}

function* handleCategorySaveFailedFn(
  action: WebSocketCategorySaveFailedAction,
) {
  try {
    const { requestId, categoryId, errorMessage } = action.payload || {};
    const state = yield* select();
    const pendingCategorySaveRequestIds =
      state.productList?.pendingCategorySaveRequestIds || {};

    // Get category ID from WebSocket event (available to all users) or from saveInfo (only for user who saved)
    const saveInfo = pendingCategorySaveRequestIds[requestId];
    const targetCategoryId = categoryId || saveInfo?.categoryId || "";

    if (!targetCategoryId) return;

    // Show reload modal to ANY user currently viewing this category (regardless of who saved)
    yield* call(showReloadModalIfCurrentCategory, targetCategoryId);

    // Only show toast and alert if this requestId was initiated by the current user
    if (saveInfo) {
      const categoryNames = yield* select(selectCategoryNamesByIds, [
        targetCategoryId,
      ]);
      const categoryName = categoryNames[0] || targetCategoryId || "";
      const message = `Save failed for category ${categoryName}.${errorMessage ? ` ${errorMessage}` : ""}`;

      // Show error alert (original)
      yield* put(
        addGlobalAlertState({
          alertsProps: [
            {
              descriptor: {
                id: "productListOperations.updateProductSequenceFailure",
                defaultMessage:
                  "Failed to update product sequences, please try after sometime.",
              },
              severity: "error",
              variant: "standard",
            },
          ],
        }),
      );

      yield* put(
        showSnackbar({
          message,
          variant: "error",
          categoryId: targetCategoryId,
          errorMessage: errorMessage || "Unknown error",
          retryPayload: saveInfo.payload, // Store payload for retry
          key: `save-failed-${requestId}`,
        }),
      );

      // Remove requestId from pendingCategorySaveRequestIds after processing
      yield* put(clearPendingSaveRequestId(requestId));
    }
  } catch (e: any) {
    console.error("Error handling category save failure:", e);
  }
}

function* getSortedProductsListFn(action: GetSortedProductsListAction) {
  const actionType = FETCH_SORTED_PRODUCTS;
  try {
    const requestId = action.payload.requestId;
    const categoryId = action.payload.categoryId;
    const catalogId = action.payload.catalogId;
    const ruleId = action.payload.ruleId;
    const isUnmanagedProductsSupported =
      action.payload.isUnmanagedProductsSupported;
    const constName = Object.keys({ FETCH_SORTED_PRODUCTS })[0].toString();
    const serviceType = LOAD_ASYNC_REQUEST_SERVICE_URL;
    const endpoint = acquireEndpoint(constName, serviceType, requestId);
    const optionsObj = {
      showGenericError: false,
    };
    while (true) {
      const res = yield* call(
        callApi,
        actionType,
        getData,
        null,
        endpoint,
        {},
        optionsObj,
      );
      const result = res.payload;
      if (result && result?.response?.statusCode) {
        if (result?.response?.statusCode <= 204) {
          const products = result.response?.body?.products || [];
          yield* put(asyncSortProgressStop());
          yield* call(loadCurrentPageSortedProductsDetails, { products });
          let promotedProducts: string[] = [];
          let demotedProducts: string[] = [];

          if (
            isUnmanagedProductsSupported &&
            ruleId &&
            isSmartSortRuleId(ruleId)
          ) {
            const isPromoteRule = isSmartSortPromoteRule(ruleId);

            products.forEach((product) => {
              const score = product.score ?? 0;

              if (isPromoteRule) {
                if (score > 0) {
                  promotedProducts.push(product.productId);
                }
              } else {
                if (score < 1) {
                  demotedProducts.push(product.productId);
                }
              }
            });

            yield* put(
              updateSortedProductsPositions({
                promotedProducts,
                demotedProducts,
                categoryId,
                catalogId,
              }),
            );
          }

          yield* put({
            type: SET_ACTIVE_SORTING_RULE,
            payload: ruleId,
          });
          break;
        } else if (result?.response?.statusCode >= 400) {
          yield* put({
            type: FETCH_SORTED_PRODUCTS.FAILURE,
            payload: { categoryId },
          });
          yield* put(asyncSortProgressStop());
          yield* put(
            addGlobalAlertState({
              alertsProps: [
                {
                  descriptor: {
                    id: "productListOperations.getSortedProductsListFailure",
                    defaultMessage:
                      "Failed to retrieve sorted products, please try again after some time.",
                  },
                  severity: "error",
                  variant: "standard",
                },
              ],
            }),
          );
          break;
        }
      }
      yield* call(delay, 5000);
    }
  } catch (e: any) {
    console.error(e);
    yield* put(asyncSortProgressStop());
  }
}

function* prefetchRemainingPagesSaga(action: PrefetchRemainingPagesAction) {
  const {
    categoryId,
    catalogId,
    storeId,
    localeCode,
    pageSize,
    remainingProductIds,
    requestContextId,
  } = action.payload;
  try {
    // Iterate the raw productId list in chunks of pageSize. Each chunk is
    // handed to getProductDetailsPerPage, which internally fans it out to a
    // pool of PRODUCT_DETAILS_MAX_WORKERS workers — so peak concurrency stays
    // at the existing 6 in-flight API requests. Sequential chunks keep total
    // backend load bounded.
    for (let i = 0; i < remainingProductIds.length; i += pageSize) {
      // Defensive bail-out if the user switched context after the race fires
      // but before this iteration runs.
      const currentCtx = yield* select(selectPrefetchContextId);
      if (currentCtx !== requestContextId) break;

      const batch = remainingProductIds.slice(i, i + pageSize);
      const allProducts = yield* select(selectProducts);
      const missing = batch.filter(
        (id: string) => !allProducts[id]?.productDetailsLoaded,
      );
      if (missing.length === 0) continue;

      // `page` is bookkeeping only — when `productIds` is provided, the
      // per-page saga skips its page-derivation logic and just chunks the IDs.
      // `requestContextId` is propagated down to the worker so it can drop
      // late-arriving responses if the user has switched context.
      yield* call(getProductDetailsPerPage, {
        type: FETCH_PRODUCT_DETAILS_PER_PAGE.REQUEST,
        payload: {
          categoryId,
          catalogId,
          storeId,
          localeCode,
          productIds: missing,
          page: Math.floor(i / pageSize) + 2,
          pageSize,
          requestContextId,
        },
      });
    }
    yield* put({ type: PREFETCH_REMAINING_PAGES.SUCCESS });
  } catch (e: any) {
    console.error("prefetchRemainingPagesSaga error", e);
    yield* put({
      type: PREFETCH_REMAINING_PAGES.FAILURE,
      message: e?.message,
    });
  }
}

export function* watchLoadProductsFromCategory() {
  yield* takeEvery(LOAD_PRODUCT_LIST, getProductsFromCategory);
}

export function* watchCategoryChange() {
  let task;
  while (true) {
    const action = yield* take(CATEGORY_CHANGE);
    if (task) {
      yield* cancel(task); // Cancel previous loading task if it's inflight
      yield* put(productLoadingCancelled());
    }
    task = yield* fork(
      getProductsFromCategory,
      action as LoadProductsFromCategoryAction,
    ); // Start a new product loading task
  }
}

export function* watchUpdateProductListSequence() {
  yield* takeEvery(CHANGE_PRODUCT_LIST_SEQUENCE, updateProductSequence);
}
export function* watchUpdateProductSequence() {
  yield* takeEvery(UPDATE_PRODUCT_SEQUENCE, updateProductSequenceFn);
}
export function* watchUpdatePinnedProducts() {
  yield* takeEvery(CHANGE_PINNED_PRODUCTS, updatePinnedProducts);
}

export function* watchLoadSortingRulesList() {
  yield* takeEvery(LOAD_SORTING_LIST, getSortingRulesList);
}

export function* watchSortedProductsList() {
  yield* takeEvery(LOAD_SORTED_PRODUCTS, getSortedProductsListAsynchronously);
}

export function* watchRefreshProductAction() {
  yield* takeEvery(REFRESH_PRODUCT.REQUEST, getUpdatedProductInfo);
}

/**
 * Watcher for V1 category-product loads.
 *
 * - FETCH_PRODUCT_IDS.REQUEST (category change, reload): cancels both the
 *   previous initial task AND any in-flight page task, then starts a fresh
 *   initial load. Stops the old ID-fetch loop, worker pool, and badge fetch
 *   when the user navigates away mid-load.
 * - FETCH_PAGE_COLOR_BADGE_DATA.REQUEST (page change within the same category):
 *   cancels only the previous page task; the initial-IDs task keeps running so
 *   later pages continue to unlock.
 */
export function* watchProductIdsFromCategory() {
  let initialTask: Task | undefined;
  let pageTask: Task | undefined;
  while (true) {
    const action = yield* take([
      FETCH_PRODUCT_IDS.REQUEST,
      FETCH_PAGE_COLOR_BADGE_DATA.REQUEST,
      RESET_ALL_STATE,
      "SET_CURRENT_STORE",
      "SET_CATALOG_ID",
      "SET_CURRENT_LOCALE",
      RESET_PRODUCT_LIST,
      CANCEL_PRODUCT_LIST_FETCH,
    ]);
    if (
      action.type === RESET_ALL_STATE ||
      action.type === "SET_CURRENT_STORE" ||
      action.type === "SET_CATALOG_ID" ||
      action.type === "SET_CURRENT_LOCALE" ||
      action.type === RESET_PRODUCT_LIST ||
      action.type === CANCEL_PRODUCT_LIST_FETCH
    ) {
      if (initialTask) yield* cancel(initialTask);
      if (pageTask) yield* cancel(pageTask);
      initialTask = undefined;
      pageTask = undefined;
      yield* put({ type: FETCH_PRODUCT_LIST.STOP });
    } else if (action.type === FETCH_PRODUCT_IDS.REQUEST) {
      if (initialTask) yield* cancel(initialTask);
      if (pageTask) yield* cancel(pageTask);
      pageTask = undefined;
      initialTask = yield* fork(getProductIdsFromCategory, action as any);
    } else {
      if (pageTask) yield* cancel(pageTask);
      pageTask = yield* fork(
        getProductsColorAndBadgeDataOnPageChange,
        action as any,
      );
    }
  }
}

export function* watchPrevProductIdsFromCategory() {
  yield* takeEvery(
    FETCH_PREV_PRODUCT_IDS.REQUEST,
    getPreviousProductIdsFromCategory,
  );
}

export function* watchNextProductIdsFromCategory() {
  yield* takeEvery(
    FETCH_NEXT_PRODUCT_IDS.REQUEST,
    getNextProductIdsFromCategory,
  );
}

export function* watchGetProductSequenceList() {
  yield* takeEvery(GET_PRODUCT_SEQUENCE, getProductSequenceFn);
}

export function* watchFetchInProgressRequestsSnapshot() {
  yield* takeEvery(
    FETCH_IN_PROGRESS_REQUESTS_SNAPSHOT.REQUEST,
    fetchInProgressRequestsSnapshotFn,
  );
}

export function* watchCheckCategorySave() {
  yield* takeEvery(CHECK_CATEGORY_SAVE, checkCategorySaveFn);
}

export function* watchCategorySaveStarted() {
  yield* takeEvery(
    WEBSOCKET_CATEGORY_SAVE_STARTED,
    handleCategorySaveStartedFn,
  );
}

export function* watchCategorySaveCompleted() {
  yield* takeEvery(
    WEBSOCKET_CATEGORY_SAVE_COMPLETED,
    handleCategorySaveCompletedFn,
  );
}

export function* watchCategorySaveFailed() {
  yield* takeEvery(WEBSOCKET_CATEGORY_SAVE_FAILED, handleCategorySaveFailedFn);
}

export function* watchFetchUpdatedProductAction() {
  yield* takeEvery(FETCH_PRODUCT.REQUEST, getUpdatedProductInfo);
}

export function* watchRefreshProductColorAction() {
  yield* takeEvery(REFRESH_PRODUCT_COLOR.REQUEST, getUpdatedProductColorInfo);
}

export function* watchFetchProductsColorsData() {
  yield* takeEvery(
    FETCH_PRODUCTS_COLORS.REQUEST,
    fetchProductsColorDataHandler,
  );
}

export function* watchLoadProductListAction() {
  yield* takeEvery(FETCH_WATCHED_PRODUCT_LIST.REQUEST, getWatchedProductList);
}

export function* watchAddProductToWatchList() {
  yield* takeEvery(ADD_PRODUCT_TO_WATCH_LIST.REQUEST, addProductToWatchList);
}

export function* watchRemoveProductFromWatchList() {
  yield* takeEvery(
    REMOVE_PRODUCT_FROM_WATCH_LIST.REQUEST,
    removeProductFromWatchList,
  );
}

export function* watchLockProduct() {
  yield* takeEvery(LOCK_PRODUCT.REQUEST, lockProduct);
}

export function* watchUnlockProduct() {
  yield* takeEvery(UNLOCK_PRODUCT.REQUEST, unLockProduct);
}

export function* watchGetLocksForCategory() {
  yield* takeEvery(FETCH_LOCKS_FOR_CATEGORY.REQUEST, getLocksForCategory);
}

export function* watchGetContentSlots() {
  yield* takeEvery(GET_CONTENT_SLOTS.REQUEST, getContentSlots);
}

export function* watchAddContentSlot() {
  yield* takeEvery(ADD_CONTENT_SLOT.REQUEST, addContentSlot);
}

export function* watchUpdateContentSlot() {
  yield* takeEvery(UPDATE_CONTENT_SLOT.REQUEST, updateContentSlot);
}

export function* watchDeleteContentSlot() {
  yield* takeEvery(DELETE_CONTENT_SLOT.REQUEST, deleteContentSlot);
}

export function* watchGetPinnedProducts() {
  yield* takeEvery(GET_PINNED_PRODUCTS.REQUEST, getPinnedProducts);
}

export function* watchSetPinnedProducts() {
  yield* takeEvery(SET_PINNED_PRODUCTS.REQUEST, setPinnedProducts);
}

export function* watchDiscardOutOfPositionProducts() {
  yield* takeEvery(
    DISCARD_OUT_OF_POSITION_PRODUCTS,
    discardOutOfPositionProducts,
  );
}

export function* watchAddUpdateContentSlot() {
  yield* takeEvery(ADD_UPDATE_CONTENT_SLOT, addUpdateContentSlot);
}

export function* watchDeleteUpdateContentSlot() {
  yield* takeEvery(DELETE_UPDATE_CONTENT_SLOT, deleteUpdateContentSlot);
}

export function* watchProductList() {
  yield* takeLatest(FETCH_PRODUCT_LIST.REQUEST, getProductsFromCategory);
}

export function* watchProductListPageChange() {
  // Intentionally empty — handled by watchProductIdsFromCategory so the V1
  // initial task and page task share scheduling and cancellation rules.
}

/**
 * Watcher for category-product loads.
 *
 * - LOAD_INITIAL_PRODUCTS_DETAILS.REQUEST (category change, reload): cancels
 *   both the previous initial task AND any in-flight page task, then starts
 *   a fresh initial load. This is what stops the ID-fetch loop and worker
 *   pool when the user navigates away mid-load.
 * - FETCH_PRODUCT_DETAILS_PER_PAGE.REQUEST (page change within the same
 *   category): cancels only the previous page task. The initial load is left
 *   alone so its background ID-fetch loop keeps populating pages 2..N.
 */
export function* watchLoadInitialProducts() {
  let initialTask: Task | undefined;
  let pageTask: Task | undefined;
  while (true) {
    const action = yield* take([
      LOAD_INITIAL_PRODUCTS_DETAILS.REQUEST,
      FETCH_PRODUCT_DETAILS_PER_PAGE.REQUEST,
      RESET_ALL_STATE,
      "SET_CURRENT_STORE",
      "SET_CATALOG_ID",
      "SET_CURRENT_LOCALE",
      RESET_PRODUCT_LIST,
      CANCEL_PRODUCT_LIST_FETCH,
    ]);
    if (
      action.type === RESET_ALL_STATE ||
      action.type === "SET_CURRENT_STORE" ||
      action.type === "SET_CATALOG_ID" ||
      action.type === "SET_CURRENT_LOCALE" ||
      action.type === RESET_PRODUCT_LIST ||
      action.type === CANCEL_PRODUCT_LIST_FETCH
    ) {
      if (initialTask) yield* cancel(initialTask);
      if (pageTask) yield* cancel(pageTask);
      initialTask = undefined;
      pageTask = undefined;
      yield* put({ type: FETCH_PRODUCT_LIST.STOP });
    } else if (action.type === LOAD_INITIAL_PRODUCTS_DETAILS.REQUEST) {
      if (initialTask) yield* cancel(initialTask);
      if (pageTask) yield* cancel(pageTask);
      pageTask = undefined;
      initialTask = yield* fork(getProductDetailsPerPage, action);
    } else {
      if (pageTask) yield* cancel(pageTask);
      pageTask = yield* fork(getProductDetailsPerPage, action);
    }
  }
}

export function* watchFetchProductDetailsPerPage() {
  // Intentionally empty — handled by watchLoadInitialProducts so the initial
  // task and the page task share scheduling and cancellation rules.
}

export function* watchUpdateSortedProductsPositions() {
  yield* takeEvery(
    UPDATE_SORTED_PRODUCTS_POSITIONS,
    updateSortedProductsPositionsSaga,
  );
}

export function* watchLoadRemainingProducts() {
  yield* takeEvery(LOAD_REMAINING_PRODUCTS.REQUEST, loadRemainingProductsSaga);
}

// Watch for changes that should cancel badge queries
export function* watchCancelBadgeQueries() {
  yield* takeEvery(RESET_PRODUCT_LIST, cancelAllBadgeQueries);
  yield* takeEvery(CATEGORY_CHANGE, cancelAllBadgeQueries);
  yield* takeEvery("SET_CURRENT_STORE", cancelAllBadgeQueries);
  yield* takeEvery("SET_CURRENT_LOCALE", cancelAllBadgeQueries);
  yield* takeEvery("SET_CATALOG_ID", cancelAllBadgeQueries);
}

export function* watchGetSortedProductsList() {
  yield* takeEvery(FETCH_SORTED_PRODUCTS.REQUEST, getSortedProductsListFn);
}

export function* watchPrefetchRemainingPages() {
  while (true) {
    const action = yield* take(PREFETCH_REMAINING_PAGES.REQUEST);
    const result = yield* race({
      task: call(
        prefetchRemainingPagesSaga,
        action as PrefetchRemainingPagesAction,
      ),
      cancel: take([
        LOAD_INITIAL_PRODUCTS_DETAILS.REQUEST,
        RESET_PRODUCT_LIST,
        "SET_CURRENT_STORE",
        "SET_CATALOG_ID",
        "SET_CURRENT_LOCALE",
        CANCEL_PRODUCT_LIST_FETCH,
        PREFETCH_REMAINING_PAGES.CANCEL,
      ]),
    });
    if (result.cancel) {
      // Reset still-"loading" pages back to "idle" so subsequent clicks
      // trigger a fresh fetch instead of waiting on a cancelled task.
      yield* put({ type: PREFETCH_REMAINING_PAGES.CANCEL });
    }
  }
}
